/* Test-Or : comportements communs (landing + fiche produit). Aucune dépendance. */
(function () {
  "use strict";

  var reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var stock = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    getS: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    setS: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var euros = function (n) {
    return n.toLocaleString("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  // Interpolation sur requestAnimationFrame (sortie douce) : pas(p) reçoit p de 0 à 1
  var animer = function (duree, pas) {
    var t0 = 0;
    var tic = function (t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / duree); pas(1 - Math.pow(1 - p, 3)); if (p < 1) requestAnimationFrame(tic); };
    requestAnimationFrame(tic);
  };
  var IO = "IntersectionObserver" in window;
  // Ajout groupé au panier (kit + accessoires, produit + recharge) : Shopify range chaque article reçu par /cart/add.js en tête
  // du panier, donc le dernier de la liste s'affiche en premier. La liste part à l'envers : le premier article (le kit) reste en
  // tête du panier latéral et de la page panier (relevé sur la prévisualisation, 9 oct. 2026, Claude Code pour Raphaël).
  var ordrePanier = function (items) { return items.slice().reverse(); };

  /* Annotations « à brancher » : ?annotations=0 pour les masquer */
  if (/[?&]annotations=0/.test(location.search)) document.body.classList.add("sans-annotations");

  /* ================================================== COMPTE À REBOURS (heure de Paris)
     Honnête par construction : heure limite réelle d'un jour ouvré (expédition), ou date de fin fixe (offre).
     Jamais de minuteur qui se réinitialise, de faux stock ni de faux compteur : pratiques commerciales trompeuses. */
  var FMT_PARIS = (function () {
    try { return new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }); } catch (e) { return null; }
  })();
  var paris = function (t) {
    var d = new Date(t);
    if (!FMT_PARIS) return { a: d.getFullYear(), m: d.getMonth() + 1, j: d.getDate(), h: d.getHours(), mi: d.getMinutes() };
    var o = {}; FMT_PARIS.formatToParts(d).forEach(function (x) { o[x.type] = x.value; });
    return { a: +o.year, m: +o.month, j: +o.day, h: +o.hour % 24, mi: +o.minute };
  };
  // Instant (ms) d'une heure de Paris, changement d'heure compris
  var instantParis = function (a, m, j, h, mi) {
    var vise = Date.UTC(a, m - 1, j, h, mi), t = vise;
    for (var k = 0; k < 3; k++) { var p = paris(t); t += vise - Date.UTC(p.a, p.m - 1, p.j, p.h, p.mi); }
    return t;
  };
  // Un jour de Paris est représenté par une Date à minuit UTC
  var estOuvre = function (d, feries) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && feries.indexOf(d.toISOString().slice(0, 10)) < 0; };
  var ouvreSuivant = function (d, feries) { var r = new Date(d); do { r.setUTCDate(r.getUTCDate() + 1); } while (!estOuvre(r, feries)); return r; };
  var lireFeries = function (el) { return (el.getAttribute("data-feries") || "").match(/\d{4}-\d{2}-\d{2}/g) || []; };
  // Jour d'expédition : aujourd'hui si c'est un jour ouvré avant l'heure limite, sinon le prochain jour ouvré
  var expedition = function (limite, feries) {
    var t = Date.now(), p = paris(t), jour = new Date(Date.UTC(p.a, p.m - 1, p.j));
    var fin = instantParis(p.a, p.m, p.j, limite, 0);
    if (estOuvre(jour, feries) && t < fin) return { auj: true, jour: jour, ref: jour, reste: fin - t };
    return { auj: false, jour: ouvreSuivant(jour, feries), ref: jour };
  };
  var duree = function (ms) {
    var min = Math.max(1, Math.ceil(ms / 60000)), j = Math.floor(min / 1440), h = Math.floor((min % 1440) / 60), m = min % 60;
    if (j) return j + " j " + h + " h";
    return h ? h + " h " + m + " min" : m + " min";
  };
  var nomJour = function (cible, ref) {
    var n = Math.round((cible - ref) / 864e5);
    if (n === 1) return "demain";
    if (n >= 7) return "le " + cible.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" });
    return cible.toLocaleDateString("fr-FR", { weekday: "long", timeZone: "UTC" });
  };
  var majComptes = function () {
    $$("[data-compte]").forEach(function (el) {
      var sortie = $("[data-compte-texte]", el);
      if (!sortie) return;
      if (el.getAttribute("data-compte") === "offre") {
        var m = (el.getAttribute("data-fin") || "").match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
        var reste = m ? instantParis(+m[1], +m[2], +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59) - Date.now() : 0;
        if (reste <= 0) { var creneau = el.closest(".annonce__slide"); (creneau || el).remove(); return; } // terminée : ne se relance jamais
        sortie.textContent = (el.getAttribute("data-texte") || "Fin dans [duree]").replace("[duree]", duree(reste));
        el.hidden = false;
        return;
      }
      var e = expedition(parseInt(el.getAttribute("data-limite") || "14", 10), lireFeries(el));
      sortie.textContent = e.auj
        ? (el.getAttribute("data-avant") || "Commandez dans [duree] : expédié aujourd'hui").replace("[duree]", duree(e.reste))
        : (el.getAttribute("data-apres") || "Commandez maintenant : expédié [jour]").replace("[jour]", nomJour(e.jour, e.ref));
    });
  };
  majComptes();
  $$(".annonce").forEach(function (b) {
    var slides = $$(".annonce__slide", b);
    if (slides.length && !$(".annonce__slide.is-active", b)) { slides[0].classList.add("is-active"); slides[0].removeAttribute("aria-hidden"); }
  });
  setInterval(majComptes, 20000);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) majComptes(); });

  /* ---------------------------------------------------------------- Annonce */
  $$(".annonce").forEach(function (bloc) {
    var slides = $$(".annonce__slide", bloc);
    if (slides.length < 2) return;
    var i = 0, minuterie, enPause = false;
    var montrer = function (n) {
      slides[i].classList.remove("is-active");
      slides[i].setAttribute("aria-hidden", "true");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("is-active");
      slides[i].removeAttribute("aria-hidden");
    };
    // 2 nov. 2026 (A33, CS-I12) : lancer() efface d'abord la minuterie en cours (jamais deux à la fois) et ne repart pas si la pause est demandée.
    var lancer = function () { clearInterval(minuterie); if (!reduit && !enPause) minuterie = setInterval(function () { montrer(i + 1); }, 4500); };
    var prec = $(".annonce__nav--prec", bloc), suiv = $(".annonce__nav--suiv", bloc), pause = $(".annonce__pause", bloc);
    if (prec) prec.addEventListener("click", function () { clearInterval(minuterie); montrer(i - 1); lancer(); });
    if (suiv) suiv.addEventListener("click", function () { clearInterval(minuterie); montrer(i + 1); lancer(); });
    bloc.addEventListener("mouseenter", function () { clearInterval(minuterie); });
    bloc.addEventListener("mouseleave", lancer);
    // Au clavier aussi : la rotation s'arrête tant que le focus est dans la barre (critère WCAG 2.2.2, arrêter, mettre en pause, masquer).
    bloc.addEventListener("focusin", function () { clearInterval(minuterie); });
    bloc.addEventListener("focusout", lancer);
    // Bouton pause : visible seulement quand les messages tournent (pas sous « réduire les animations »).
    if (pause && !reduit) {
      pause.hidden = false;
      pause.addEventListener("click", function () {
        enPause = !enPause;
        pause.setAttribute("aria-pressed", enPause ? "true" : "false");
        pause.setAttribute("aria-label", enPause ? "Reprendre les messages" : "Mettre en pause les messages");
        var pictogramme = $("use", pause);
        if (pictogramme) pictogramme.setAttribute("href", enPause ? "#i-play" : "#i-pause");
        lancer();
      });
    }
    lancer();
  });

  /* ------------------------------------------- En-tête collant : ombre au défilement */
  var entete = $(".entete");
  if (entete) {
    var ombre = false;
    var surDefilement = function () {
      var doit = window.scrollY > 8;
      if (doit !== ombre) { ombre = doit; entete.classList.toggle("is-defile", ombre); }
    };
    window.addEventListener("scroll", surDefilement, { passive: true });
    // 21 oct. 2026 : premier calcul à la frame suivante, pour ne pas forcer une mise en page pendant le chargement
    requestAnimationFrame(surDefilement);
  }

  /* ------------------------------------------------------------ Menu mobile */
  var menu = $("#menu-mobile");
  if (menu) {
    var ouvrirMenu = $$("[data-ouvrir-menu]"), fermerMenu = $$("[data-fermer-menu]", menu);
    var basculer = function (ouvert) {
      menu.classList.toggle("is-open", ouvert);
      menu.setAttribute("aria-hidden", ouvert ? "false" : "true");
      ouvrirMenu.forEach(function (b) { b.setAttribute("aria-expanded", ouvert ? "true" : "false"); });
      document.documentElement.style.overflow = ouvert ? "hidden" : "";
      if (ouvert) { var f = $("a, button", menu); if (f) f.focus(); } else if (ouvrirMenu[0]) ouvrirMenu[0].focus();
    };
    ouvrirMenu.forEach(function (b) { b.addEventListener("click", function () { basculer(true); }); });
    fermerMenu.forEach(function (b) { b.addEventListener("click", function () { basculer(false); }); });
    $$("nav a", menu).forEach(function (a) { a.addEventListener("click", function () { basculer(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && menu.classList.contains("is-open")) basculer(false); });
  }

  /* --------------------------------------------------- Apparition au défilement, en cascade
     Les éléments qui entrent ensemble (une rangée de grille) apparaissent l'un après l'autre, à 75 ms d'écart.
     Grilles sans classe revele (cartes produit, guides, situations) : animées seulement si elles sont sous la ligne
     de flottaison au chargement, pour ne jamais masquer un contenu déjà affiché. Fin d'apparition : classes retirées,
     l'élément retrouve ses propres transitions (survol). */
  var DECALAGE = 75;
  var finRevele = function (el) {
    var fait = false;
    var nettoyer = function () { if (fait) return; fait = true; el.classList.remove("revele", "is-in"); el.style.transitionDelay = ""; };
    el.addEventListener("transitionend", function f(e) { if (e.target === el && e.propertyName === "opacity") { el.removeEventListener("transitionend", f); nettoyer(); } });
    setTimeout(nettoyer, 1500 + (parseFloat(el.style.transitionDelay) || 0));
  };
  if (IO && !reduit) {
    var hauteurEcran = window.innerHeight;
    var pistes = $$(".carrousel:not(.carrousel--avis) > .carrousel__piste");
    var enfants = $$(".cartes-produits > li, .guides-grille > li");
    // Lectures groupées, puis écritures
    var pistesBas = pistes.filter(function (p) { return p.getBoundingClientRect().top > hauteurEcran; });
    var enfantsBas = enfants.filter(function (li) { return !li.classList.contains("revele") && li.getBoundingClientRect().top > hauteurEcran; });
    pistesBas.forEach(function (p) { Array.prototype.forEach.call(p.children, function (c) { c.classList.add("revele"); }); });
    enfantsBas.forEach(function (li) { li.classList.add("revele"); });
    var obs = new IntersectionObserver(function (entrees) {
      var lot = [];
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        if (e.target.classList.contains("carrousel__piste")) lot = lot.concat($$(":scope > .revele", e.target));
        else lot.push(e.target);
      });
      lot.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
      lot.forEach(function (el, k) {
        el.style.transitionDelay = Math.min(k, 6) * DECALAGE + "ms";
        el.classList.add("is-in");
        finRevele(el);
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    $$(".revele").forEach(function (el) { if (pistesBas.indexOf(el.parentNode) < 0) obs.observe(el); });
    pistesBas.forEach(function (p) { obs.observe(p); });
    // 1er nov. 2026 (A22) : l'observateur est installé. Le script du <head> (layout/test-or.liquid) retire la classe a-revele au bout de 4 s s'il ne voit pas cet attribut.
    document.documentElement.setAttribute("data-revele-pret", "");
  } else {
    $$(".revele").forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ------------------------------------- Chiffres clés réels (« environ 100 essais », « 30 jours ») : comptage à l'apparition
     Seulement sous la ligne de flottaison au chargement : un chiffre déjà affiché n'est jamais remis à zéro.
     Le chiffre final reste dans le DOM jusqu'au départ de l'animation, lancé 80 px avant l'apparition :
     les agents IA, les lecteurs d'écran et l'extraction de texte lisent « 30 jours », jamais « 0 jours ». */
  if (IO && !reduit) {
    var RE_CHIFFRE = /(^|\s)(\d{2,4})(?=\s(?:essais|jours)\b)/;
    var compteurs = [];
    $$(".methode-gagnante li, .raison p, .kit__liste li, .chiffre").forEach(function (el) {
      if (el.getBoundingClientRect().top <= window.innerHeight) return;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, m;
      while ((n = w.nextNode())) {
        if (!(m = RE_CHIFFRE.exec(n.nodeValue))) continue;
        var nombre = n.splitText(m.index + m[1].length);
        nombre.splitText(m[2].length);
        var span = document.createElement("span");
        span.className = "compteur";
        span.setAttribute("data-fin", m[2]);
        span.style.minWidth = m[2].length + "ch";
        span.textContent = m[2];
        nombre.parentNode.replaceChild(span, nombre);
        compteurs.push(span);
        break;
      }
    });
    if (compteurs.length) {
      var obsC = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (!e.isIntersecting) return;
          obsC.unobserve(e.target);
          var fin = parseInt(e.target.getAttribute("data-fin"), 10), el = e.target;
          animer(900, function (p) { el.textContent = String(Math.round(fin * p)); });
        });
      }, { rootMargin: "0px 0px 80px 0px" });
      compteurs.forEach(function (c) { obsC.observe(c); });
    }
  }

  /* ------------------------------------------- Héros : très léger parallaxe de l'image (20 px au plus) */
  var heroMedia = $(".hero__media");
  if (heroMedia && !reduit) {
    var hHero = heroMedia.parentNode.offsetHeight, parallaxePrevue = false;
    var parallaxe = function () {
      parallaxePrevue = false;
      var y = Math.min(20, window.scrollY * 0.05);
      heroMedia.style.transform = y > 0 ? "translate3d(0, " + y.toFixed(1) + "px, 0)" : "";
    };
    window.addEventListener("scroll", function () {
      if (!parallaxePrevue && window.scrollY < hHero + 40) { parallaxePrevue = true; requestAnimationFrame(parallaxe); }
    }, { passive: true });
    window.addEventListener("resize", function () { hHero = heroMedia.parentNode.offsetHeight; });
  }

  /* ------------------------------------------- Étapes : ligne de progression tracée au défilement (CSS --progres) */
  $$(".etapes:not(.etapes--quatre)").forEach(function (el) {
    if (reduit || !IO || el.children.length !== 3) return;
    var prevue = false, actif = false;
    var maj = function () {
      prevue = false;
      var r = el.getBoundingClientRect(), h = window.innerHeight;
      el.style.setProperty("--progres", Math.max(0, Math.min(1, (h * 0.85 - r.top) / (h * 0.5))).toFixed(3));
    };
    var demander = function () { if (actif && !prevue) { prevue = true; requestAnimationFrame(maj); } };
    el.style.setProperty("--progres", "0");
    new IntersectionObserver(function (e) { actif = e[0].isIntersecting; demander(); }).observe(el);
    window.addEventListener("scroll", demander, { passive: true });
  });

  /* ------------------------------------------------------ Vidéo du héros */
  $$("video.hero__video").forEach(function (v) {
    var mobile = window.matchMedia("(max-width: 767px)").matches;
    var src = v.getAttribute(mobile ? "data-src-mobile" : "data-src-desktop") || v.getAttribute("data-src-desktop");
    if (!src || reduit) { v.remove(); return; }
    v.muted = true; v.playsInline = true;
    if (mobile && v.getAttribute("data-poster-mobile")) v.poster = v.getAttribute("data-poster-mobile");
    v.addEventListener("canplay", function () { v.classList.add("is-prete"); var p = v.play(); if (p && p.catch) p.catch(function () {}); }, { once: true });
    v.addEventListener("error", function () { v.remove(); }, true);
    v.src = src;
  });

  /* -------------------------------------------------------- Avant / après */
  $$(".comparateur").forEach(function (c) {
    var range = $(".comparateur__range", c);
    if (!range) return;
    var maj = function () { c.style.setProperty("--pos", range.value + "%"); };
    range.addEventListener("input", maj);
    maj();
  });

  /* ------------------------------------------------------------ Carrousels */
  $$(".carrousel:not([data-avis])").forEach(function (car) {
    var piste = $(".carrousel__piste", car);
    var prec = $("[data-carrousel-prec]", car), suiv = $("[data-carrousel-suiv]", car);
    if (!piste || !prec || !suiv) return;
    var pas = function () { var c = piste.children[0]; return c ? c.getBoundingClientRect().width + 18 : 300; };
    var etat = function () {
      prec.disabled = piste.scrollLeft < 8;
      suiv.disabled = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
    };
    prec.addEventListener("click", function () { piste.scrollBy({ left: -pas(), behavior: reduit ? "auto" : "smooth" }); });
    suiv.addEventListener("click", function () { piste.scrollBy({ left: pas(), behavior: reduit ? "auto" : "smooth" }); });
    piste.addEventListener("scroll", etat, { passive: true });
    window.addEventListener("resize", etat);
    etat();
  });

  /* ------------------------------------------------------------ Estimateur (bijou, poids, titre, puis trois barresEst) */
  var est = $("[data-estimateur]");
  if (est) {
    var cours = parseFloat(est.getAttribute("data-cours")) || 0;
    var poids = $("input[name='poids']", est), sortieP = $("[data-poids-sortie]", est), sortie = $("[data-estimation]", est);
    var libT = $("[data-titre-lib]", est), barresEst = $$("[data-barre]", est);
    var affiche = null, tour = 0;
    var grammes = function (n) { return String(Math.round(n * 10) / 10).replace(".", ",") + " g"; };
    var ecrireEst = function (x) {
      sortie.textContent = "≈ " + euros(x.v);
      barresEst.forEach(function (li, i) { $("[data-barre-val]", li).textContent = euros(x.b[i]); });
    };
    var calculer = function (e) {
      // Un objet choisi place le curseur sur son poids moyen (et son titre s'il est imposé : pièce, lingotin)
      if (e && e.target && e.target.name === "bijou") {
        poids.value = e.target.value;
        var imp = e.target.getAttribute("data-titre"), r = imp && $("input[name='titre'][data-carats='" + imp + "']", est);
        if (r) r.checked = true;
      }
      var t = $("input[name='titre']:checked", est), titre = parseFloat(t.value), carats = t.getAttribute("data-carats");
      var g = Math.max(0, parseFloat(poids.value) || 0);
      sortieP.textContent = grammes(g);
      poids.style.setProperty("--p", ((g - poids.min) / (poids.max - poids.min) * 100) + "%");
      libT.textContent = carats + " carats";
      barresEst.forEach(function (li) { li.classList.toggle("is-choisi", li.getAttribute("data-carats") === carats); });
      var cible = { v: Math.round(g * titre * cours), b: barresEst.map(function (li) { return Math.round(g * parseFloat(li.getAttribute("data-barre")) * cours); }) };
      tour++;
      if (reduit || !affiche || document.hidden) { affiche = cible; ecrireEst(cible); return; }
      // Les montants défilent jusqu'à leur nouvelle valeur
      var de = affiche, moi = tour;
      animer(400, function (p) {
        if (moi !== tour) return;
        affiche = { v: Math.round(de.v + (cible.v - de.v) * p), b: cible.b.map(function (x, i) { return Math.round(de.b[i] + (x - de.b[i]) * p); }) };
        ecrireEst(affiche);
      });
    };
    est.addEventListener("input", calculer);
    est.addEventListener("change", calculer);
    calculer();

    // Cours de l'or en coursDirect (gold-api.com, € par once troy). Repli : cours saisi et sa date, sans mention « en coursDirect ».
    var coursDirect = $("[data-cours-direct]", est);
    if (coursDirect && coursDirect.getAttribute("data-cours-direct") === "1" && window.fetch) {
      var appliquerCours = function (d) {
        var g = d.prix / 31.1034768;
        if (!(g > 20 && g < 1000)) return;
        cours = g;
        est.setAttribute("data-cours", g.toFixed(2));
        $("[data-cours-valeur]", coursDirect).textContent = g.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €/g";
        $("[data-cours-statut]", coursDirect).textContent = "En direct";
        var h = new Date(d.maj).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris" }).replace(":", " h ");
        // 2 nov. 2026 (A33, CS-C17) : la source du cours en direct est nommée à côté de l'heure.
        $("[data-cours-maj]", coursDirect).textContent = "mis à jour à " + h + " · source gold-api.com";
        coursDirect.classList.add("is-direct");
        calculer();
      };
      var coursCache = null;
      try { coursCache = JSON.parse(stock.getS("to-cours-or") || "null"); } catch (e) {}
      if (coursCache && Date.now() - coursCache.t < 600000) appliquerCours(coursCache);
      else {
        var chargerCours = function () {
          var coursCtrl = window.AbortController ? new AbortController() : null;
          if (coursCtrl) setTimeout(function () { coursCtrl.abort(); }, 5000);
          fetch("https://api.gold-api.com/price/XAU/EUR", coursCtrl ? { signal: coursCtrl.signal } : {})
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) {
              if (!j || !j.price) return;
              var d = { prix: j.price, maj: j.updatedAt || new Date().toISOString(), t: Date.now() };
              stock.setS("to-cours-or", JSON.stringify(d));
              appliquerCours(d);
            })
            .catch(function () {});
        };
        // 12 oct. 2026 : le cours en direct n'est demandé qu'à l'approche de l'estimateur (400 px avant), plus au chargement :
        // sur l'accueil il se trouve à plus de 6 000 px du haut. Le cours saisi s'affiche en attendant.
        if (window.IntersectionObserver) {
          var obsCours = new IntersectionObserver(function (es) {
            if (es.some(function (e) { return e.isIntersecting; })) { obsCours.disconnect(); chargerCours(); }
          }, { rootMargin: "400px 0px" });
          obsCours.observe(est);
        } else chargerCours();
      }
    }
  }

  /* ------------------------------------------------------- Remise mystère */
  var mystere = $("#mystere"), onglet = $("#mystere-onglet");
  if (mystere) {
    var CLE_REFUS = "to-mystere-refus", CLE_OK = "to-mystere-inscrit";
    var etapes = $$(".mystere__etape", mystere);
    var barres = $$(".mystere__progress span", mystere);
    var dejaMontre = false;
    var aller = function (n) {
      etapes.forEach(function (e, i) { e.hidden = i !== n; });
      barres.forEach(function (b, i) { b.classList.toggle("is-on", i <= n); });
      var champ = $("input[type='email']", etapes[n]);
      if (champ) setTimeout(function () { champ.focus(); }, 50);
    };
    var ouvrir = function () {
      if (mystere.classList.contains("is-open")) return;
      dejaMontre = true;
      mystere.classList.add("is-open");
      mystere.setAttribute("aria-hidden", "false");
      document.body.classList.add("mystere-ouvert");
      if (stock.get(CLE_OK)) aller(2);
    };
    var fermer = function (refus) {
      mystere.classList.remove("is-open");
      mystere.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mystere-ouvert");
      if (refus) stock.set(CLE_REFUS, String(Date.now()));
      if (onglet) onglet.focus({ preventScroll: true });
    };
    $$("[data-fermer-mystere]", mystere).forEach(function (b) { b.addEventListener("click", function () { fermer(true); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && mystere.classList.contains("is-open")) fermer(true); });
    $$("[data-choix]", mystere).forEach(function (b) {
      b.addEventListener("click", function () {
        var champ = $("input[name='contact[tags]']", mystere);
        if (champ) champ.value = "remise-mystere," + b.getAttribute("data-choix");
        aller(1);
      });
    });
    var form = $("form", mystere);
    if (form) form.addEventListener("submit", function (e) {
      // Prototype : on révèle tout de suite. Shopify : le formulaire client recharge la page,
      // puis data-reveler (form.posted_successfully?) rouvre la carte sur le code.
      if (form.hasAttribute("data-demo")) { e.preventDefault(); stock.set(CLE_OK, "1"); aller(2); }
    });
    if (mystere.hasAttribute("data-reveler") && !$("[data-popup-page][data-reveler]")) { stock.set(CLE_OK, "1"); setTimeout(function () { ouvrir(); aller(2); }, 300); }
    var copier = $("[data-copier]", mystere);
    if (copier) copier.addEventListener("click", function () {
      var code = copier.getAttribute("data-copier");
      if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
      copier.textContent = "Copié";
      setTimeout(function () { copier.textContent = "Copier"; }, 1800);
    });

    // Déclenchement discret : jamais à l'arrivée (règle Google sur les interstitiels mobiles).
    var refusRecent = function () { var t = parseInt(stock.get(CLE_REFUS) || "0", 10); return Date.now() - t < 3 * 864e5; };
    var popupPage = !!$("[data-popup-page]");
    var auto = function () {
      if (popupPage || dejaMontre || refusRecent() || stock.get(CLE_OK) || stock.getS("to-mystere-vu") || stock.getS("to-popup-vu")) return;
      stock.setS("to-mystere-vu", "1"); stock.setS("to-popup-vu", "1"); ouvrir();
    };
    var mobile = window.matchMedia("(max-width: 767px)").matches;
    setTimeout(function () {
      var delai = parseInt(mystere.getAttribute("data-delai") || "", 10) * 1000;
      setTimeout(auto, delai || (mobile ? 25000 : 15000));
      window.addEventListener("scroll", function surScroll() {
        var p = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        if (p > (mobile ? 0.55 : 0.4)) { window.removeEventListener("scroll", surScroll); auto(); }
      }, { passive: true });
      if (!mobile) document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) auto(); });
    }, 6000);

    if (onglet) {
      if (stock.getS("to-onglet-ferme")) onglet.hidden = true;
      if (!onglet.hidden && !reduit && !stock.getS("to-onglet-oscille")) {
        stock.setS("to-onglet-oscille", "1");
        setTimeout(function () { onglet.classList.add("is-oscille"); }, 2500);
        onglet.addEventListener("animationend", function () { onglet.classList.remove("is-oscille"); }, { once: true });
      }
      onglet.addEventListener("click", function (e) {
        if (e.target.closest("[data-fermer-onglet]")) {
          e.stopPropagation();
          onglet.hidden = true;
          stock.setS("to-onglet-ferme", "1");
          return;
        }
        ouvrir();
      });
    }
  }

  /* ------------------------------------------------ Barre d'achat collante */
  var barre = $("[data-barre-achat]");
  var declencheur = $("[data-barre-declencheur]");
  if (barre && declencheur && "IntersectionObserver" in window) {
    var cachePar = $$("[data-barre-cache]");
    var visibleDecl = true, visiblesCache = 0;
    // Fiche produit sur mobile et tablette (14 oct. 2026) : la barre est là dès le premier écran, tant que le bouton du
    // formulaire n'est pas visible ; ailleurs (et sur ordinateur), elle n'apparaît qu'une fois ce bouton dépassé.
    // Recalculé quand la largeur franchit 1000 px (tablette tournée).
    var barreProduit = barre.classList.contains("barre-achat--produit"), mqBarre = window.matchMedia("(max-width: 999px)"), desLeDebut = false;
    var maj = function () { barre.classList.toggle("is-visible", !visibleDecl && visiblesCache === 0); };
    var calculer = function () {
      var r = declencheur.getBoundingClientRect(), dansEcran = r.bottom > 0 && r.top < window.innerHeight;
      visibleDecl = dansEcran || (!desLeDebut && r.top > 0); maj();
    };
    var regler = function (e) {
      if (e) barre.style.transition = "none"; // passage du seuil de 1000 px : la barre change de bord sans glisser sur l'en-tête
      // 15 oct. 2026 : aussi sur ordinateur (barre en bas dès l'arrivée, le bouton du formulaire tombant sous la ligne de flottaison)
      desLeDebut = barreProduit; document.body.classList.toggle("a-barre-achat", desLeDebut); calculer();
      if (e) { void barre.offsetWidth; barre.style.transition = ""; }
    };
    new IntersectionObserver(calculer).observe(declencheur);
    if (mqBarre.addEventListener) mqBarre.addEventListener("change", regler);
    regler();
    // Bulle de l'assistant : masquée tant que le premier écran de la fiche est affiché (voir test-or.css, a-defile)
    if (barreProduit) {
      var defile = function () { document.body.classList.toggle("a-defile", window.scrollY > window.innerHeight * 0.5); };
      window.addEventListener("scroll", defile, { passive: true }); defile();
    }
    if (cachePar.length) {
      var etats = new Map();
      var obsCache = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) { etats.set(e.target, e.isIntersecting); });
        visiblesCache = 0; etats.forEach(function (v) { if (v) visiblesCache++; });
        maj();
      });
      cachePar.forEach(function (el) { obsCache.observe(el); });
    }
  }

  /* ================================================================ PANIER LATÉRAL
     Shopify : section to-panier, mise à jour par la Section Rendering API (réponse de /cart/add.js et /cart/change.js).
     Maquette (data-demo) : panier de démonstration en localStorage, rendu avec le même balisage. */
  var panier = $("div[data-panier]"); // le formulaire produit porte aussi data-panier (URL du panier)
  if (panier) (function () {
    var demo = panier.hasAttribute("data-demo");
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var dernierFocus = null, caseCochee = false, compteVu = false;
    var esc = function (x) { return String(x == null ? "" : x).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    var ic = function (n) { return '<svg class="icon" aria-hidden="true"><use href="#i-' + n + '"/></svg>'; };

    var ouvrir = function () {
      if (!panier.classList.contains("is-open")) dernierFocus = document.activeElement;
      panier.classList.add("is-open");
      panier.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("panier-ouvert");
      var f = $(".panier__haut [data-panier-fermer]", panier);
      if (f) setTimeout(function () { f.focus(); }, 60);
    };
    var fermer = function () {
      panier.classList.remove("is-open");
      panier.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("panier-ouvert");
      if (dernierFocus && dernierFocus.focus) dernierFocus.focus({ preventScroll: true });
    };
    var erreur = function (msg) { var el = $("[data-panier-erreur]", panier); if (el) { el.textContent = msg || ""; el.hidden = !msg; } };
    // Pastille du nombre d'articles sur l'icône panier de l'en-tête (créée au besoin, sans toucher au gabarit de l'en-tête)
    var majCompteur = function (nb) {
      $$(".entete a[href$='/cart'], .entete a[aria-label^='Panier']").forEach(function (a) {
        var pastille = $(".panier-compte", a);
        if (!pastille && nb > 0) { pastille = document.createElement("span"); pastille.className = "panier-compte"; pastille.setAttribute("aria-hidden", "true"); a.appendChild(pastille); }
        if (pastille) {
          var change = compteVu && pastille.textContent !== String(nb);
          pastille.textContent = String(nb); pastille.hidden = nb === 0;
          if (change && !reduit) { pastille.classList.remove("is-maj"); requestAnimationFrame(function () { pastille.classList.add("is-maj"); }); }
        }
        a.setAttribute("aria-label", "Panier, " + nb + " article" + (nb > 1 ? "s" : ""));
      });
      compteVu = true;
    };
    var liensPanier = function () { return $$(".entete a[href$='/cart'], .entete a[aria-label^='Panier']").filter(function (a) { return a.offsetParent !== null; }); };
    var rebondir = function () {
      if (reduit) return;
      liensPanier().forEach(function (a) {
        a.classList.remove("is-rebond");
        requestAnimationFrame(function () { a.classList.add("is-rebond"); });
        a.addEventListener("animationend", function () { a.classList.remove("is-rebond"); }, { once: true });
      });
    };
    // Sur ordinateur : une petite pastille dorée vole de la photo vers l'icône panier (transform seulement)
    var voler = function (source) {
      if (reduit || !source || !window.matchMedia("(min-width: 1000px) and (hover: hover)").matches) return null;
      var cible = liensPanier()[0];
      if (!cible) return null;
      var r0 = source.getBoundingClientRect(), r1 = cible.getBoundingClientRect();
      if (!r0.width || r0.bottom < 0 || r0.top > window.innerHeight) return null;
      var bille = document.createElement("span");
      bille.className = "vol-panier";
      bille.setAttribute("aria-hidden", "true");
      bille.style.cssText = "--x0:" + (r0.left + r0.width / 2) + "px;--y0:" + (r0.top + r0.height / 2) + "px;--x1:" +
        (r1.left + r1.width / 2) + "px;--y1:" + (r1.top + r1.height / 2) + "px";
      document.body.appendChild(bille);
      return new Promise(function (ok) {
        var fin = function () { if (bille.parentNode) bille.remove(); ok(true); };
        bille.addEventListener("animationend", fin);
        setTimeout(fin, 900);
      });
    };
    var brancher = function () {
      var c = $("[data-panier-contenu]", panier);
      majCompteur(parseInt(c.getAttribute("data-panier-nb") || "0", 10));
      // Case à cocher avant paiement (déclaration professionnelle) : bouton désactivé tant qu'elle n'est pas cochée
      var caseP = $("[data-panier-case]", panier), payer = $("[data-panier-paiement]", panier);
      if (caseP && payer) {
        caseP.checked = caseCochee;
        var etat = function () { caseCochee = caseP.checked; payer.disabled = !caseP.checked; };
        caseP.addEventListener("change", etat);
        etat();
      }
      majComptes();
    };

    /* ---- Shopify */
    var appel = function (url, corps) {
      corps.sections = "to-panier";
      corps.sections_url = location.pathname;
      return fetch(racine + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(corps) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    };
    var appliquer = function (j) {
      var html = j && j.sections && j.sections["to-panier"];
      if (!html) return fetch(racine + "?sections=to-panier").then(function (r) { return r.json(); }).then(function (x) { appliquer({ sections: x }); });
      var nouveau = new DOMParser().parseFromString(html, "text/html").querySelector("[data-panier-contenu]");
      var actuel = $("[data-panier-contenu]", panier);
      if (nouveau && actuel) actuel.replaceWith(document.importNode(nouveau, true));
      brancher();
    };
    var shopify = {
      ajouter: function (items) { return appel("cart/add.js", { items: ordrePanier(items) }).then(appliquer); },
      changer: function (cle, q) { return appel("cart/change.js", { id: cle, quantity: q }).then(appliquer); },
      // Codes promo : la liste complète des codes voulus (vide : tous retirés) ; renvoie cart.discount_codes [{ code, applicable }]
      codes: function (liste) {
        return appel("cart/update.js", { discount: liste.join(",") }).then(function (j) {
          return Promise.resolve(appliquer(j)).then(function () { return j.discount_codes || []; });
        });
      }
    };

    /* ---- Maquette : panier de démonstration */
    var CLE = "to-panier-demo";
    var R = {};
    try { R = JSON.parse(($("script[data-panier-reglages]", panier) || {}).textContent || "{}"); } catch (e) {}
    var lire = function () { try { return JSON.parse(stock.get(CLE) || "[]"); } catch (e) { return []; } };
    var ecrire = function (l) { stock.set(CLE, JSON.stringify(l)); };
    var cleLigne = function (x) { return x.handle + "|" + x.variante; };
    // Simulation des réductions automatiques « prix dégressifs » : quantité totale des produits concernés
    var remiseDemo = function (l) {
      var D = R.degressif, q = 0, r = 0;
      if (!D) return 0;
      l.forEach(function (x) { if (x.handle.indexOf(D.prefixe) === 0) q += x.quantite; });
      D.paliers.forEach(function (pal) { if (q >= pal[0]) r = pal[1]; });
      return r;
    };
    var jauge = function (classe, icone, texte, pct, label) {
      return '<div class="jauge-panier' + classe + '"><p>' + ic(icone) + "<span>" + texte + '</span></p><div class="jauge" role="progressbar" aria-label="' + esc(label) +
        '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width: ' + pct + '%"></span></div></div>';
    };
    var palier = function (seuil, total, avant, ok, produit, classe, icone, exemple) {
      var reste = Math.round((seuil - total) * 100) / 100, pct = Math.min(100, Math.floor(total * 100 / seuil));
      var t = reste > 0 ? esc(avant).replace("[reste]", "<strong>" + euros(reste) + "</strong>") : esc(ok);
      t = t.replace("[produit]", esc(produit || ""));
      return jauge(classe + (reste > 0 ? "" : " is-atteint"), icone, t + (exemple ? ' <span class="tag-todo">exemple de réglage</span>' : ""), pct, ok);
    };
    var vignette = function (x) { return x.image ? '<img src="' + esc(x.image) + '" alt="" width="80" height="80" loading="lazy">' : ""; };
    // Code promo de démonstration (R.code_demo) : remise en % sur les lignes dont le handle commence par l'un des préfixes
    var CLE_CODES = "to-panier-codes";
    var lireCodes = function () { try { return JSON.parse(stock.get(CLE_CODES) || "[]"); } catch (e) { return []; } };
    var champCode = function (codesL) {
      var C = R.code_promo;
      if (!C) return "";
      return '<div class="panier__code" data-code-promo data-ok="' + esc(C.ok) + '" data-ko="' + esc(C.ko) + '" data-retire="' + esc(C.retire) + '" data-vide="' + esc(C.vide) + '">' +
        '<form class="code-panier" action="#" method="post" data-panier-code-form novalidate><label class="sr-only" for="panier-code">' + esc(C.placeholder) + "</label>" +
        '<input id="panier-code" type="text" name="discount" placeholder="' + esc(C.placeholder) + '" autocomplete="off" autocapitalize="characters" spellcheck="false">' +
        '<button class="btn btn--ghost" type="submit">' + esc(C.bouton) + "</button></form>" +
        (codesL.length ? '<ul class="code-panier__liste" role="list">' + codesL.map(function (c) {
          return "<li><span>" + esc(c) + '</span><button type="button" data-panier-code-retirer="' + esc(c) + '" aria-label="Retirer le code ' + esc(c) + '">Retirer</button></li>';
        }).join("") + "</ul>" : "") +
        '<p class="code-panier__etat" data-panier-code-etat aria-live="polite"></p></div>';
    };
    var rendreDemo = function () {
      var l = lire(), nb = 0, total = 0, r = remiseDemo(l), dans = {}, codesL = lireCodes(), remiseCode = 0, CD = R.code_demo;
      l.forEach(function (x) { nb += x.quantite; dans[x.handle] = true; });
      var h = '<div class="panier__haut"><p class="panier__titre" id="panier-titre">' + esc(R.titre) + (nb ? " <span>(" + nb + ")</span>" : "") +
        '</p><button class="icone-btn" type="button" data-panier-fermer aria-label="Fermer le panier">' + ic("x") + "</button></div>" +
        '<p class="panier__erreur" data-panier-erreur role="alert" hidden></p>';
      if (!nb) {
        h += '<div class="panier__vide">' + ic("bag") + "<p>" + esc(R.vide_texte) + '</p><a class="btn btn--primary" href="' + esc(R.vide_lien) + '">' + esc(R.vide_bouton) + "</a></div>";
      } else {
        var lignes = l.map(function (x) {
          var plein = Math.round(x.prix * 100) * x.quantite;
          var final = R.degressif && x.handle.indexOf(R.degressif.prefixe) === 0 && r ? Math.round(plein * (100 - r) / 100) : plein;
          total += final;
          if (CD && codesL.indexOf(CD.code) >= 0 && CD.prefixes.some(function (pf) { return x.handle.indexOf(pf) === 0; })) remiseCode += Math.round(final * CD.pct / 100);
          return '<li class="panier-ligne" data-cle="' + esc(cleLigne(x)) + '"><a class="panier-ligne__img" href="' + esc(x.url || "#") + '" tabindex="-1" aria-hidden="true">' + vignette(x) + "</a>" +
            '<div class="panier-ligne__txt"><a class="panier-ligne__nom" href="' + esc(x.url || "#") + '">' + esc(x.titre) + "</a>" +
            (x.variante ? '<span class="panier-ligne__variante">' + esc(x.variante) + "</span>" : "") +
            (final < plein ? '<span class="panier-ligne__remise">' + esc(R.degressif.titre) + " −" + r + " % : −" + euros((plein - final) / 100) + ' <span class="tag-todo">réduction automatique</span></span>' : "") +
            '<div class="qte" role="group" aria-label="Quantité de ' + esc(x.titre) + '"><button type="button" data-panier-qte="' + (x.quantite - 1) + '" aria-label="Retirer un article">−</button>' +
            '<input type="number" inputmode="numeric" min="0" value="' + x.quantite + '" aria-label="Quantité" data-panier-saisie>' +
            '<button type="button" data-panier-qte="' + (x.quantite + 1) + '" aria-label="Ajouter un article">+</button></div></div>' +
            '<div class="panier-ligne__prix">' + (final < plein ? "<s>" + euros(plein / 100) + "</s>" : "") + "<strong>" + euros(final / 100) + "</strong>" +
            '<button class="panier-ligne__suppr" type="button" data-panier-qte="0">Supprimer</button></div></li>';
        }).join("");
        total = (total - remiseCode) / 100;
        h += '<div class="panier__defile">';
        if (R.seuil) h += palier(R.seuil, total, R.livraison_avant, R.livraison_ok, "", "", "truck", false);
        if (R.cadeau) h += palier(R.cadeau.seuil, total, R.cadeau_avant, R.cadeau_ok, R.cadeau.titre, " jauge-panier--cadeau", "gift", true);
        if (R.compte) h += '<div class="panier__compte"><span class="compte" data-compte="expedition" data-limite="' + R.compte.limite + '" data-avant="' + esc(R.compte.avant) +
          '" data-apres="' + esc(R.compte.apres) + '">' + ic("clock") + "<span data-compte-texte>" + esc(R.compte.secours) + "</span></span></div>";
        h += '<ul class="panier__lignes" role="list">' + lignes + "</ul>";
        // Suggestion : la recharge des réactifs du panier, sinon la liste réglée
        var proposes = [], titreS = R.suggestion_titre_recharge;
        l.forEach(function (x) { (x.codes || "").split(",").forEach(function (c) { var s2 = R.recharges[c]; if (s2 && !dans[s2.handle] && proposes.indexOf(s2) < 0) proposes.push(s2); }); });
        if (!proposes.length) { titreS = R.suggestion_titre; proposes = R.suggestions.filter(function (s2) { return !dans[s2.handle]; }); }
        if (proposes.length) {
          h += '<div class="panier__sugg"><p class="panier__sous-titre">' + esc(titreS) + "</p>" + proposes.slice(0, 2).map(function (s2) {
            return '<div class="panier-sugg"><span class="panier-sugg__img">' + vignette(s2) + '</span><span class="panier-sugg__txt"><a href="' + esc(s2.url) + '">' + esc(s2.titre) + "</a><span>" +
              (s2.variante ? esc(s2.variante) + " · " : "") + euros(s2.prix) + '</span></span><button class="btn btn--ghost panier-sugg__btn" type="button" data-panier-ajouter data-produit="' +
              esc(JSON.stringify(s2)) + '">Ajouter</button></div>';
          }).join("") + "</div>";
        }
        if (R.reassurance && R.reassurance.length) h += '<ul class="panier__reassurance" role="list">' + R.reassurance.map(function (x) { return "<li>" + ic(x[0]) + esc(x[1]) + "</li>"; }).join("") + "</ul>";
        h += "</div>";
        h += '<div class="panier__bas">' + champCode(codesL) + '<form class="panier__paiement" action="#" method="post" data-panier-form data-demo>' +
          (remiseCode ? '<p class="panier__remise"><span>' + esc(CD.code) + " (" + esc(CD.libelle) + " −" + CD.pct + ' %) <span class="tag-todo">démo</span></span><span>−' + euros(remiseCode / 100) + "</span></p>" : "") +
          '<p class="panier__total"><span>Sous-total</span><strong>' + euros(total) + "</strong></p>" +
          (R.note ? '<p class="panier__note">' + esc(R.note) + "</p>" : "") +
          (R.case_texte ? '<label class="panier__case"><input type="checkbox" required data-panier-case><span>' + esc(R.case_texte) + ' <span class="tag-todo">exemple de réglage</span></span></label>' : "") +
          '<button class="btn btn--primary btn--lg btn--block" type="submit" name="checkout" data-panier-paiement>' + ic("lock") + esc(R.bouton) + "</button>" +
          '<div class="paiements paiements--clair" aria-label="Moyens de paiement acceptés">' + (R.paiements || []).map(function (x) { return '<img src="assets/img/paiements/' + esc(x.f) + '.svg" alt="' + esc(x.n) + '" width="38" height="24">'; }).join("") + "</div></form></div>";
      }
      var c = $("[data-panier-contenu]", panier);
      c.innerHTML = h;
      c.setAttribute("data-panier-nb", String(nb));
      brancher();
    };
    var maquette = {
      ajouter: function (items) {
        var l = lire();
        items.forEach(function (it) {
          var x = l.filter(function (y) { return cleLigne(y) === cleLigne(it); })[0];
          if (x) x.quantite += it.quantite || 1; else { it.quantite = it.quantite || 1; l.push(it); }
        });
        ecrire(l); rendreDemo();
        return Promise.resolve();
      },
      changer: function (cle, q) {
        ecrire(lire().map(function (y) { if (cleLigne(y) === cle) y.quantite = q; return y; }).filter(function (y) { return y.quantite > 0; }));
        rendreDemo();
        return Promise.resolve();
      },
      codes: function (liste) {
        var CD = R.code_demo || {};
        var res = liste.map(function (c) { var bon = !!CD.code && c.toUpperCase() === CD.code; return { code: bon ? CD.code : c, applicable: bon }; });
        stock.set(CLE_CODES, JSON.stringify(res.filter(function (x) { return x.applicable; }).map(function (x) { return x.code; })));
        rendreDemo();
        return Promise.resolve(res);
      }
    };

    var api = demo ? maquette : shopify;
    var occupe = function (on) { var c = $("[data-panier-contenu]", panier); if (c) c.setAttribute("aria-busy", on ? "true" : "false"); };
    var echec = function (j) { occupe(false); erreur((j && (j.description || j.message)) || "Le panier n'a pas pu être mis à jour. Réessayez."); };
    var changer = function (cle, q) { occupe(true); api.changer(cle, q).then(function () { occupe(false); }, echec); };

    // Code promo : appliqué par l'API panier (discount de /cart/update.js) ; code inconnu ou inapplicable retiré aussitôt ;
    // repli sur /discount/CODE si l'API échoue. Messages lus sur [data-code-promo] (réglages de la section).
    var codesActuels = function () { return $$("[data-panier-code-retirer]", panier).map(function (b) { return b.getAttribute("data-panier-code-retirer"); }); };
    var messageCode = function (cle, code, err) {
      var bloc = $("[data-code-promo]", panier), el = $("[data-panier-code-etat]", panier);
      if (!bloc || !el) return;
      el.textContent = (bloc.getAttribute("data-" + cle) || "").replace("[code]", code);
      el.classList.toggle("is-erreur", !!err);
    };
    var appliquerCode = function (code) {
      code = (code || "").trim();
      if (!code) { messageCode("vide", "", true); return; }
      var avant = codesActuels();
      if (avant.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { messageCode("ok", code); return; }
      occupe(true);
      api.codes(avant.concat(code)).then(function (liste) {
        var trouve = liste.filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0];
        if (trouve && trouve.applicable) { occupe(false); messageCode("ok", trouve.code); return; }
        return api.codes(avant).then(function () { occupe(false); messageCode("ko", code, true); });
      }).catch(function () {
        occupe(false);
        if (demo) { messageCode("ko", code, true); return; }
        location.href = racine + "discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(location.pathname + location.search);
      });
    };
    var retirerCode = function (code) {
      occupe(true);
      api.codes(codesActuels().filter(function (c) { return c !== code; })).then(function () { occupe(false); messageCode("retire", code); }, echec);
    };
    window.TestOrPanier = {
      ouvrir: ouvrir,
      fermer: fermer,
      ajouter: function (items, source) {
        var vol = voler(source);
        return Promise.all([api.ajouter(items), vol]).then(function () {
          rebondir();
          if (vol) setTimeout(ouvrir, 220); else ouvrir(); // laisse voir le rebond avant le tiroir
        }, function (j) {
          if (j && (j.description || j.message)) { ouvrir(); erreur(j.description || j.message); return; }
          throw j;
        });
      }
    };

    panier.addEventListener("click", function (e) {
      if (e.target.closest("[data-panier-fermer]")) { fermer(); return; }
      var rc = e.target.closest("[data-panier-code-retirer]");
      if (rc) { retirerCode(rc.getAttribute("data-panier-code-retirer")); return; }
      var q = e.target.closest("[data-panier-qte]");
      if (q) changer(q.closest("[data-cle]").getAttribute("data-cle"), Math.max(0, parseInt(q.getAttribute("data-panier-qte"), 10) || 0));
    });
    panier.addEventListener("change", function (e) {
      if (e.target.matches("[data-panier-saisie]")) changer(e.target.closest("[data-cle]").getAttribute("data-cle"), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
    panier.addEventListener("submit", function (e) {
      if (e.target.matches("[data-panier-code-form]")) { e.preventDefault(); appliquerCode($("input", e.target).value); return; }
      if (!e.target.hasAttribute("data-demo")) return;
      e.preventDefault();
      erreur("Démonstration : le paiement se fait dans Shopify.");
    });
    panier.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var f = $$("a[href], button:not([disabled]), input:not([disabled])", $(".panier__tiroir", panier)).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && panier.classList.contains("is-open")) fermer(); });
    // Icône panier de l'en-tête et boutons d'ajout en un clic (cartes produit, suggestions)
    document.addEventListener("click", function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      var lien = e.target.closest(".entete a[href$='/cart'], .entete a[aria-label^='Panier'], [data-panier-ouvrir]");
      if (lien) { e.preventDefault(); ouvrir(); return; }
      var b = e.target.closest("[data-panier-ajouter]");
      if (!b) return;
      e.preventDefault();
      b.setAttribute("aria-busy", "true");
      var items = demo ? [JSON.parse(b.getAttribute("data-produit") || "{}")] : [{ id: parseInt(b.getAttribute("data-panier-ajouter"), 10), quantity: 1 }];
      var carte = b.closest(".carte-produit");
      var source = carte ? $(".carte-produit__media", carte) : null;
      window.TestOrPanier.ajouter(items, source).then(function () { b.removeAttribute("aria-busy"); }, function () { b.removeAttribute("aria-busy"); });
    });
    if (demo) rendreDemo(); else brancher();
  })();

  /* ================================================================ CATALOGUE : filtres et tri
     Shopify : chaque choix recharge la grille filtrée (paramètres Search & Discovery). Maquette : filtrage sur place. */
  $$("form[data-facettes]").forEach(function (f) {
    var demoF = f.hasAttribute("data-demo");
    var tiroir = $("[data-facettes-tiroir]", f);
    if (tiroir && window.matchMedia("(min-width: 980px)").matches) tiroir.open = true;
    var grille = $("[data-catalogue-grille]"), nbF = $("[data-catalogue-nb]"), puces = $("[data-catalogue-puces]");
    var filtrerDemo = function () {
      var donnees = new FormData(f), types = donnees.getAll("type"), reactifs = donnees.getAll("reactif");
      var min = parseFloat(donnees.get("prix_min")) || 0, max = parseFloat(donnees.get("prix_max")) || Infinity, tri = donnees.get("sort_by");
      var cartes = $$("li[data-type]", grille), bandeau = $(".cartes-produits__bandeau", grille), n = 0;
      cartes.forEach(function (li) {
        var codes = (li.getAttribute("data-codes") || "").split(","), prix = parseFloat(li.getAttribute("data-prix"));
        var ok = (!types.length || types.indexOf(li.getAttribute("data-type")) >= 0) &&
          (!reactifs.length || reactifs.some(function (r) { return codes.indexOf(r) >= 0; })) && prix >= min && prix <= max;
        li.hidden = !ok;
        if (ok) n++;
      });
      var cle = { "price-ascending": function (a, b) { return a.getAttribute("data-prix") - b.getAttribute("data-prix"); },
                  "price-descending": function (a, b) { return b.getAttribute("data-prix") - a.getAttribute("data-prix"); },
                  "title-ascending": function (a, b) { return a.getAttribute("data-titre").localeCompare(b.getAttribute("data-titre"), "fr"); } }[tri] ||
                function (a, b) { return a.getAttribute("data-rang") - b.getAttribute("data-rang"); };
      cartes.sort(cle).forEach(function (li) { grille.appendChild(li); });
      if (bandeau) { var visibles = cartes.filter(function (li) { return !li.hidden; }); var apres = visibles[3] || visibles[visibles.length - 1]; if (apres) apres.after(bandeau); bandeau.hidden = !visibles.length; }
      if (nbF) nbF.textContent = n + " produit" + (n > 1 ? "s" : "");
      var vide = $("[data-catalogue-vide]"); if (vide) vide.hidden = n > 0;
      if (puces) {
        var actifs = $$("input:checked", f).map(function (i) { return '<button class="puce-filtre" type="button" data-retirer="' + i.id + '">' + i.parentNode.querySelector("span").textContent + '<svg class="icon" aria-hidden="true"><use href="#i-x"/></svg></button>'; });
        if (min || max < Infinity) actifs.push('<button class="puce-filtre" type="button" data-retirer="prix">Prix<svg class="icon" aria-hidden="true"><use href="#i-x"/></svg></button>');
        puces.innerHTML = actifs.length ? actifs.join("") + '<button class="puce-filtre puce-filtre--effacer" type="button" data-retirer="tout">Tout effacer</button>' : "";
        puces.hidden = !actifs.length;
      }
    };
    var envoyer = function () {
      if (demoF) { filtrerDemo(); return; }
      var params = new URLSearchParams();
      new FormData(f).forEach(function (v, k) { if (String(v).trim() !== "") params.append(k, v); });
      location.search = params.toString();
    };
    f.addEventListener("change", envoyer);
    f.addEventListener("submit", function (e) { e.preventDefault(); envoyer(); });
    $$("select[form='" + f.id + "']").forEach(function (sel) { sel.addEventListener("change", envoyer); });
    if (puces) puces.addEventListener("click", function (e) {
      var b = e.target.closest("[data-retirer]"); if (!b) return;
      var id = b.getAttribute("data-retirer");
      if (id === "tout") { $$("input", f).forEach(function (i) { if (i.type === "checkbox") i.checked = false; else i.value = ""; }); }
      else if (id === "prix") { $$("input[type='number']", f).forEach(function (i) { i.value = ""; }); }
      else { var i = document.getElementById(id); if (i) i.checked = false; }
      envoyer();
    });
  });

  /* ================================================================ RECHERCHE (maquette : recherche sur place) */
  var rechDemo = $("[data-recherche-demo]");
  if (rechDemo) {
    var terme = (new URLSearchParams(location.search).get("q") || "").trim();
    var norm = function (x) { return x.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); };
    var mots = norm(terme).split(/\s+/).filter(Boolean);
    var champR = $("input[name='q']", rechDemo); if (champR) champR.value = terme;
    var trouves = 0;
    $$("[data-resultat]").forEach(function (el) {
      var ok = mots.length > 0 && mots.every(function (m) { return norm(el.getAttribute("data-resultat")).indexOf(m) >= 0; });
      el.hidden = !ok;
      if (ok) trouves++;
    });
    $$("[data-groupe]").forEach(function (g) { g.hidden = !$$("[data-resultat]", g).some(function (el) { return !el.hidden; }); });
    var titreR = $("[data-recherche-titre]");
    if (titreR && terme) titreR.textContent = "Résultats pour « " + terme + " »";
    var nbR = $("[data-recherche-nb]"); if (nbR) { nbR.hidden = !trouves; nbR.textContent = trouves + " résultat" + (trouves > 1 ? "s" : ""); }
    $$("[data-recherche-vide]").forEach(function (el) { el.hidden = trouves > 0; });
    var vt = $("[data-recherche-vide-titre]"); if (vt) vt.hidden = !terme;
  }

  /* ================================================================ CARROUSEL D'AVIS
     « Lire la suite » au-delà de cinq lignes. Défilement continu et lent (data-avis-auto : pixels par seconde), sans fin
     grâce à des copies des cartes masquées aux technologies d'assistance ; pause au survol, au focus clavier, au toucher
     et par le bouton. Moins d'animations demandé : aucun défilement automatique. Flèches et swipe dans tous les cas. */
  $$("[data-avis]").forEach(function (car) {
    var piste = $(".carrousel__piste", car);
    if (!piste) return;
    var prec = $("[data-carrousel-prec]", car), suiv = $("[data-carrousel-suiv]", car), pause = $("[data-avis-pause]", car);
    var vitesse = parseFloat(car.getAttribute("data-avis-auto")) || 0;
    var originaux = Array.prototype.slice.call(piste.children);
    var boucle = 0; // largeur d'un jeu de cartes quand la boucle est en place

    // Lire la suite : coupe seulement les textes qui dépassent (écritures groupées, puis lectures, puis écritures)
    var couper = function () {
      var textes = $$(".avis__texte", piste);
      textes.forEach(function (t) { t.classList.add("est-coupe"); });
      var depasse = textes.map(function (t) { return t.scrollHeight > t.clientHeight + 2; });
      textes.forEach(function (t, i) {
        var b = t.nextElementSibling;
        if (depasse[i] && b && b.hasAttribute("data-avis-suite")) b.hidden = false; else t.classList.remove("est-coupe");
      });
    };
    piste.addEventListener("click", function (e) {
      var b = e.target.closest("[data-avis-suite]");
      if (!b) return;
      var t = b.previousElementSibling, ouvert = !t.classList.contains("est-ouvert");
      t.classList.toggle("est-ouvert", ouvert);
      t.classList.toggle("est-coupe", !ouvert);
      b.setAttribute("aria-expanded", ouvert ? "true" : "false");
      b.textContent = ouvert ? "Réduire" : "Lire la suite";
    });

    // Flèches : une carte à la fois ; avec la boucle, on saute d'un jeu de cartes sans que cela se voie
    var pas = function () { var c = piste.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(piste).columnGap) || 18) : 300; };
    var etat = function () {
      if (!prec || !suiv) return;
      prec.disabled = !boucle && piste.scrollLeft < 8;
      suiv.disabled = !boucle && piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 8;
    };
    var aller = function (sens) {
      var d = pas();
      if (boucle && sens < 0 && piste.scrollLeft < d) piste.scrollLeft += boucle;
      else if (boucle && sens > 0 && piste.scrollLeft + d > boucle) piste.scrollLeft -= boucle;
      piste.scrollBy({ left: sens * d, behavior: reduit ? "auto" : "smooth" });
    };
    if (prec) prec.addEventListener("click", function () { aller(-1); });
    if (suiv) suiv.addEventListener("click", function () { aller(1); });
    piste.addEventListener("scroll", etat, { passive: true });
    window.addEventListener("resize", etat);
    etat();

    var auto = vitesse > 0 && !reduit && originaux.length > 1 && IO;
    if (!auto && pause) pause.hidden = true;
    var pret = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    pret.then(couper, couper).then(function () { if (auto) demarrer(); });

    var arrets = { survol: false, focus: false, toucher: false, bouton: false };
    var visible = false, raf = 0, dernier = 0, pos = 0, ecrit = 0, reprise;
    var enPause = function () { return arrets.survol || arrets.focus || arrets.toucher || arrets.bouton; };
    var tic = function (t) {
      raf = 0;
      if (!visible || document.hidden || enPause() || !boucle) { dernier = 0; return; }
      if (dernier) {
        if (Math.abs(piste.scrollLeft - ecrit) > 2) pos = piste.scrollLeft; // défilé par ailleurs : on repart de là
        pos += vitesse * Math.min(64, t - dernier) / 1000;
        if (pos >= boucle) pos -= boucle;
        piste.scrollLeft = ecrit = pos;
      }
      dernier = t;
      raf = requestAnimationFrame(tic);
    };
    var relancer = function () {
      if (raf || !boucle || !visible || document.hidden || enPause()) return;
      pos = piste.scrollLeft;
      if (pos >= boucle) { pos -= boucle; piste.scrollLeft = pos; }
      ecrit = pos;
      dernier = 0;
      raf = requestAnimationFrame(tic);
    };
    var cloner = function () {
      originaux.forEach(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute("aria-hidden", "true");
        k.setAttribute("inert", "");
        k.removeAttribute("data-shopify-editor-block");
        $$("a, button, [tabindex]", k).forEach(function (x) { x.setAttribute("tabindex", "-1"); });
        piste.appendChild(k);
      });
    };
    var mesurer = function () { boucle = piste.children[originaux.length].offsetLeft - originaux[0].offsetLeft; };
    var majPause = function () {
      if (!pause) return;
      pause.setAttribute("aria-pressed", arrets.bouton ? "true" : "false");
      pause.setAttribute("aria-label", arrets.bouton ? "Reprendre le défilement" : "Mettre en pause le défilement");
      pause.innerHTML = '<svg class="icon" aria-hidden="true"><use href="#i-' + (arrets.bouton ? "play" : "pause") + '"/></svg>';
    };
    function demarrer() {
      cloner();
      mesurer();
      for (var n = 0; n < 4 && piste.scrollWidth < boucle + piste.clientWidth + 40; n++) cloner();
      car.classList.add("is-auto");
      etat();
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; relancer(); }).observe(car);
      window.addEventListener("resize", mesurer);
      document.addEventListener("visibilitychange", relancer);
      car.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") arrets.survol = true; });
      car.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") { arrets.survol = false; relancer(); } });
      car.addEventListener("focusin", function (e) { var t = e.target; try { arrets.focus = t.matches(":focus-visible"); } catch (x) { arrets.focus = true; } });
      car.addEventListener("focusout", function (e) { if (!car.contains(e.relatedTarget)) { arrets.focus = false; relancer(); } });
      car.addEventListener("touchstart", function () { arrets.toucher = true; clearTimeout(reprise); }, { passive: true });
      car.addEventListener("touchend", function () {
        clearTimeout(reprise);
        reprise = setTimeout(function () { arrets.toucher = false; relancer(); }, 4000); // le visiteur a la main, puis ça repart
      }, { passive: true });
      if (pause) pause.addEventListener("click", function () { arrets.bouton = !arrets.bouton; majPause(); relancer(); });
    }
  });

  /* ================================================================ FAQ ET ACCORDÉONS : ouverture en hauteur fluide
     Le CSS s'en charge quand le navigateur sait animer jusqu'à « auto » (interpolate-size) ; sinon, ici. */
  if (!reduit && !(window.CSS && CSS.supports && CSS.supports("interpolate-size", "allow-keywords"))) {
    document.addEventListener("click", function (e) {
      var s = e.target.closest(".faq summary, .accordeons summary");
      if (!s) return;
      var d = s.parentNode;
      if (!d.animate) return;
      e.preventDefault();
      if (d.__anime) return;
      var ouvrir = !d.open, h0 = d.offsetHeight;
      if (ouvrir) d.open = true;
      var h1 = ouvrir ? d.offsetHeight : s.offsetHeight + (d.offsetHeight - d.clientHeight);
      d.style.overflow = "hidden";
      var a = d.__anime = d.animate([{ height: h0 + "px" }, { height: h1 + "px" }], { duration: ouvrir ? 300 : 240, easing: "cubic-bezier(.2, .7, .2, 1)" });
      a.onfinish = a.oncancel = function () { if (!ouvrir) d.open = false; d.style.overflow = ""; d.__anime = null; };
    });
  }

  /* ================================================================ LIGNES REPLIÉES (fiche produit)
     2 nov. 2026 (benchmark P6) : les sections repliées par snippets/to-repli sont des « details.repli » fermés. Le texte est dans le HTML ;
     ici, deux choses : une ancre qui vise l'intérieur d'une ligne (rappel des dangers sous le bouton : #securite-produit, lien « avis » : #avis)
     ouvre la ligne avant de défiler ; à l'ouverture, les carrousels et autres mesures de largeur sont recalculés (ils ont été lus à zéro,
     la ligne étant fermée au chargement). Sans JavaScript, les navigateurs récents ouvrent déjà la ligne d'une ancre, et le visiteur l'ouvre au clic. */
  var lignesRepli = $$("details.repli");
  if (lignesRepli.length) {
    var decoder = function (s) { try { return decodeURIComponent(s); } catch (e) { return s; } };
    var ouvrirCible = function (id) {
      var cible = id ? document.getElementById(id) : null;
      var ligne = cible && cible.closest ? cible.closest("details.repli") : null;
      if (ligne && !ligne.open) { ligne.open = true; return true; }
      return false;
    };
    var idDeLien = function (a) {
      var h = a.getAttribute("href") || "";
      if (h.charAt(0) === "#") return decoder(h.slice(1));
      try { var u = new URL(a.href, location.href); if (u.origin === location.origin && u.pathname === location.pathname) return decoder(u.hash.slice(1)); } catch (e) {}
      return "";
    };
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("a[href*='#']");
      if (a) ouvrirCible(idDeLien(a)); // l'ouverture se fait avant le défilement du navigateur vers l'ancre
    });
    window.addEventListener("hashchange", function () {
      var id = decoder(location.hash.slice(1));
      if (ouvrirCible(id)) { var c = document.getElementById(id); if (c) c.scrollIntoView(); }
    });
    var idDepart = decoder(location.hash.slice(1));
    if (idDepart && ouvrirCible(idDepart)) {
      var cibleDepart = document.getElementById(idDepart);
      if (cibleDepart) requestAnimationFrame(function () { cibleDepart.scrollIntoView(); });
    }
    lignesRepli.forEach(function (ligne) {
      ligne.addEventListener("toggle", function () { if (ligne.open) window.dispatchEvent(new Event("resize")); });
    });
  }

  /* ================================================================ FICHE PRODUIT */
  var achat = $("[data-achat]");
  if (achat) {
    var boutonPrix = $$("[data-prix-bouton]");
    var ajout = $("[data-ajout]", achat);
    var nomBarre = $("[data-nom-barre]");
    var galeries = $$("[data-galerie]");
    // Variante courante : carte de palier cochée, ou champ caché piloté par les sélecteurs d'options.
    var choixCourant = function () { return $("input[name='id']:checked", achat) || $("input[type='hidden'][name='id']", achat); };
    // Prix dégressifs : la carte cochée règle la quantité ; affichage seulement (réductions automatiques dans l'admin).
    var degressif = $("[data-degressif]", achat), champQte = $("[data-quantite]", achat);
    var palierQte = function () { return degressif ? $("input[name='to-quantite']:checked", degressif) : null; };
    var quantite = function () { var q = palierQte(); return q ? parseInt(q.value, 10) || 1 : 1; };
    // Total d'une quantité remisée, en centimes, arrondi comme une remise en pourcentage sur la ligne
    var totalRemise = function (prix, q, r) { return Math.round(Math.round(prix * 100) * q * (100 - r) / 100); };
    var prixCourant = function () {
      var p = choixCourant(), q = palierQte();
      var unit = p ? parseFloat(p.getAttribute("data-prix")) : 0;
      var base = q ? totalRemise(unit, quantite(), parseFloat(q.getAttribute("data-remise")) || 0) / 100 : unit;
      if (ajout && ajout.checked) base += parseFloat(ajout.getAttribute("data-prix")) || 0;
      return base;
    };
    var majDegressif = function () {
      if (!degressif) return;
      var p = choixCourant(), unit = p ? parseFloat(p.getAttribute("data-prix")) : 0;
      $$("input[name='to-quantite']", degressif).forEach(function (inp) {
        var q = parseInt(inp.value, 10), r = parseFloat(inp.getAttribute("data-remise")) || 0, carte = inp.parentNode;
        var total = totalRemise(unit, q, r), plein = Math.round(unit * 100) * q;
        var champs = { "[data-deg-unitaire]": Math.round(total / q), "[data-deg-total]": total, "[data-deg-eco]": plein - total };
        Object.keys(champs).forEach(function (sel) { var el = $(sel, carte); if (el) el.textContent = euros(champs[sel] / 100); });
      });
      // Cartes visuelles : nombre d'essais selon la contenance (≈ 100 par flacon de 5 ml, 300 en 15 ml)
      var parFlacon = /15\s?ml/.test((p && p.getAttribute("data-nom")) || "") ? 300 : 100;
      $$("[data-deg-essais]", degressif).forEach(function (el) { el.textContent = "≈ " + (parseInt(el.getAttribute("data-q"), 10) * parFlacon) + " essais"; });
      if (champQte) champQte.value = String(quantite());
    };
    var majPrix = function (e) {
      var p = choixCourant();
      majDegressif();
      boutonPrix.forEach(function (el) { el.textContent = euros(prixCourant()); });
      // Livraison sous le prix : « offerte » dès que le prix courant atteint le seuil (data-seuil, en euros)
      $$("[data-port]").forEach(function (el) {
        var seuil = parseFloat(el.getAttribute("data-seuil")) || 0;
        el.textContent = seuil > 0 && prixCourant() >= seuil ? el.getAttribute("data-offert") : el.getAttribute("data-normal");
      });
      if (p && nomBarre) nomBarre.textContent = p.getAttribute("data-nom");
      // Prototype : une galerie par kit. Shopify : une galerie, on défile jusqu'au visuel de la variante.
      if (p && p.hasAttribute("data-galerie-cible")) galeries.forEach(function (g) { g.hidden = g.getAttribute("data-galerie") !== p.getAttribute("data-galerie-cible"); });
      galeries.forEach(function (g) { if (!g.hidden) initGalerie(g); });
      var change = e && (e.target === p || e.type === "variante");
      if (p && change && p.hasAttribute("data-media") && galeries[0] && galeries[0].__aller) galeries[0].__aller(parseInt(p.getAttribute("data-media"), 10));
      if (p && change && /^\d+$/.test(p.value) && window.history.replaceState && !$("form[data-demo]", achat)) {
        var u = new URL(location.href); u.searchParams.set("variant", p.value); u.searchParams.delete("kit"); history.replaceState({}, "", u);
      }
      achat.dispatchEvent(new CustomEvent("variante-change"));
    };
    achat.addEventListener("change", majPrix);

    // Contenu du colis et légende de la photo : suivent le titre de la variante choisie (data-si).
    var siEls = $$("[data-si]");
    if (siEls.length) {
      var majSi = function () {
        var c = choixCourant(), nomV = c ? (c.getAttribute("data-nom") || "") : "";
        siEls.forEach(function (el) { el.hidden = nomV.indexOf(el.getAttribute("data-si")) === -1; });
      };
      achat.addEventListener("variante-change", majSi);
      majSi();
    }

    // Sélecteurs par option (Contenance, Pierre, Balance...) : retrouve la variante correspondante.
    var donnees = $("script[data-variantes]", achat);
    var cache = $("input[type='hidden'][name='id']", achat);
    if (donnees && cache) {
      var variantes = JSON.parse(donnees.textContent);
      var groupes = $$(".options", achat);
      var selection = function () { return groupes.map(function (g) { var c = $("input:checked", g); return c ? c.value : null; }); };
      var trouver = function (opts) { return variantes.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; };
      var appliquer = function () {
        var sel = selection(), v = trouver(sel);
        if (!v) return;
        cache.value = v.id; cache.setAttribute("data-prix", v.prix); cache.setAttribute("data-nom", v.titre);
        if (v.media !== null && v.media !== undefined) cache.setAttribute("data-media", v.media); else cache.removeAttribute("data-media");
        var bouton = $("button[type='submit']", achat);
        if (bouton) bouton.disabled = !v.dispo;
        // Écart de prix et disponibilité de chaque autre choix, toutes choses égales par ailleurs.
        groupes.forEach(function (g, i) {
          $$("input", g).forEach(function (inp) {
            var essai = sel.slice(); essai[i] = inp.value;
            var w = trouver(essai), ecart = $("[data-ecart]", inp.nextElementSibling);
            inp.disabled = !w || !w.dispo;
            if (ecart) { var d = w ? Math.round((w.prix - v.prix) * 100) / 100 : 0; ecart.textContent = !w || inp.checked || !d ? "" : (d > 0 ? "+" : "−") + euros(Math.abs(d)); }
          });
        });
        majPrix({ type: "variante" });
      };
      groupes.forEach(function (g) { g.addEventListener("change", function (e) { e.stopPropagation(); appliquer(); }); });
      appliquer();
    }

    // Livraison estimée : expédié aujourd'hui avant l'heure limite d'un jour ouvré (heure de Paris), sinon le prochain jour ouvré.
    var livraison = $("[data-livraison]");
    if (livraison) {
      var feriesL = lireFeries(livraison);
      var plus = function (d, n) { var r = d; while (n-- > 0) r = ouvreSuivant(r, feriesL); return r; };
      var jMin = parseInt(livraison.getAttribute("data-min") || "2", 10), jMax = parseInt(livraison.getAttribute("data-max") || "3", 10);
      var depart = expedition(parseInt(livraison.getAttribute("data-limite") || "14", 10), feriesL).jour;
      var f = function (d) { return d.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" }); };
      livraison.innerHTML = "Commandez maintenant, livré entre le <strong>" + f(plus(depart, jMin)) + "</strong> et le <strong>" + f(plus(depart, Math.max(jMin, jMax))) + "</strong>.";
    }

    var form = $("form", achat);
    if (form) form.addEventListener("submit", function (e) {
      var choisi = choixCourant();
      if (!choisi || !window.TestOrPanier) {
        if (form.hasAttribute("data-demo")) e.preventDefault();
        return; // Shopify sans panier latéral ni fetch : envoi classique du formulaire
      }
      e.preventDefault();
      var bouton = $("button[type='submit']", form); if (bouton) bouton.setAttribute("aria-busy", "true");
      var fini = function () { if (bouton) bouton.removeAttribute("aria-busy"); };
      var items;
      if (form.hasAttribute("data-demo")) {
        // Maquette : panier de démonstration (localStorage), même rendu que le panier Shopify.
        var titre = form.getAttribute("data-titre") || (($("h1", achat) || {}).textContent || "").trim();
        var nom = choisi.getAttribute("data-nom") || "";
        items = [{ handle: form.getAttribute("data-handle") || "", titre: titre, variante: nom === titre ? "" : nom, prix: parseFloat(choisi.getAttribute("data-prix")) || 0,
                   quantite: quantite(),
                   image: form.getAttribute("data-image") || "", codes: form.getAttribute("data-codes") || "", url: location.pathname.split("/").pop() }];
        if (ajout && ajout.checked) items.push({ handle: ajout.getAttribute("data-handle") || "", titre: ajout.getAttribute("data-titre") || "", variante: ajout.value,
                                                 prix: parseFloat(ajout.getAttribute("data-prix")) || 0, quantite: 1, image: ajout.getAttribute("data-image") || "",
                                                 codes: ajout.getAttribute("data-codes") || "", url: ajout.getAttribute("data-url") || "" });
      } else {
        // Shopify : le produit (quantité des prix dégressifs) et, si cochée, la recharge, en un seul appel.
        items = [{ id: parseInt(choisi.value, 10), quantity: quantite() }];
        if (ajout && ajout.checked && ajout.value) items.push({ id: parseInt(ajout.value, 10), quantity: 1 });
      }
      var galerie = $$("[data-galerie]").filter(function (g) { return !g.hidden; })[0];
      var source = (galerie && $(".galerie__slides", galerie)) || bouton;
      window.TestOrPanier.ajouter(items, source).then(fini, function () { fini(); if (!form.hasAttribute("data-demo")) form.submit(); });
    });
    $$("[data-soumettre-achat]").forEach(function (b) {
      b.addEventListener("click", function () { if (form) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });

    // Complétez votre kit (snippet to-completer, vitrine 46 et 50) : aucune case cochée d'avance ; total et bouton suivent les cases ;
    // un seul ajout au panier (AJAX du panier latéral), qui s'ouvre. « Cet article » suit la variante choisie.
    // Remise de lot (data-remise) : affichage seulement, la réduction automatique se crée dans l'admin.
    $$("[data-completer]", achat).forEach(function (bloc) {
      var base = $("[data-completer-base]", bloc), cases = $$("[data-completer-case]", bloc), btn = $("[data-completer-btn]", bloc);
      var totalEl = $("[data-completer-total]", bloc), barreEl = $("[data-completer-barre]", bloc), remiseEl = $("[data-completer-remise]", bloc);
      var pct = parseFloat(bloc.getAttribute("data-remise") || "0") || 0, vide = btn.textContent;
      var racineC = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      var dire = function (t, err) { var el = $("[data-form-retour]", bloc); if (el) { el.textContent = t; el.classList.toggle("is-erreur", !!err); } };
      var prixBase = function () { var p = choixCourant(); return p ? parseFloat(p.getAttribute("data-prix")) || 0 : 0; };
      var maj = function () {
        var p = choixCourant(), cents = 0, n = 0, extras = 0, nomEl = $("[data-completer-nom]", bloc);
        if (p && nomEl && p.getAttribute("data-nom")) nomEl.textContent = p.getAttribute("data-nom");
        $("[data-completer-prix]", bloc).textContent = euros(prixBase());
        if (base.checked) { cents += Math.round(prixBase() * 100); n++; }
        cases.forEach(function (x) { if (x.checked) { cents += Math.round(parseFloat(x.getAttribute("data-prix")) * 100); n++; extras++; } });
        var lot = pct > 0 && n > 1, final = lot ? Math.round(cents * (100 - pct) / 100) : cents;
        totalEl.textContent = euros(final / 100);
        if (barreEl) { barreEl.hidden = !lot; barreEl.textContent = euros(cents / 100); }
        if (remiseEl) { remiseEl.hidden = !lot; $("[data-completer-eco]", remiseEl).textContent = "−" + euros((cents - final) / 100); }
        btn.disabled = !extras;
        btn.textContent = !extras ? vide : (n === 1 ? "Ajouter au panier" : "Ajouter les " + n + " au panier") + " · " + euros(final / 100);
      };
      bloc.addEventListener("change", function (e) { e.stopPropagation(); maj(); dire(""); });
      achat.addEventListener("variante-change", maj);
      btn.addEventListener("click", function () {
        var f = $("form", achat), demo = !!(f && f.hasAttribute("data-demo")), p = choixCourant(), items = [];
        if (base.checked && p) {
          if (demo) {
            var titre = f.getAttribute("data-titre") || (($("h1", achat) || {}).textContent || "").trim(), nom = p.getAttribute("data-nom") || "";
            items.push({ handle: f.getAttribute("data-handle") || "", titre: titre, variante: nom === titre ? "" : nom, prix: prixBase(), quantite: 1,
                         image: f.getAttribute("data-image") || "", codes: f.getAttribute("data-codes") || "", url: location.pathname.split("/").pop() });
          } else items.push({ id: parseInt(p.value, 10), quantity: 1 });
        }
        cases.forEach(function (x) {
          if (!x.checked) return;
          if (demo) items.push({ handle: x.getAttribute("data-handle") || "", titre: x.getAttribute("data-titre") || "", variante: x.getAttribute("data-variante") || "",
                                 prix: parseFloat(x.getAttribute("data-prix")) || 0, quantite: 1, image: x.getAttribute("data-image") || "",
                                 codes: x.getAttribute("data-codes") || "", url: x.getAttribute("data-url") || "" });
          else items.push({ id: parseInt(x.value, 10), quantity: 1 });
        });
        if (!items.length) return;
        btn.setAttribute("aria-busy", "true");
        var fini = function () { btn.removeAttribute("aria-busy"); };
        var ok = function () { fini(); cases.forEach(function (x) { x.checked = false; }); base.checked = true; maj(); };
        if (window.TestOrPanier) {
          window.TestOrPanier.ajouter(items, $("img", bloc)).then(ok, function () { fini(); dire("L'ajout au panier n'a pas abouti. Réessayez.", true); });
        } else if (!demo) {
          fetch(racineC + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: ordrePanier(items) }) })
            .then(function (r) { if (!r.ok) throw r; location.href = racineC + "cart"; })
            .catch(function () { fini(); dire("L'ajout au panier n'a pas abouti. Réessayez.", true); });
        } else fini();
      });
      maj();
    });

    // ?kit=essentiel|complet|duo présélectionne le palier (liens depuis la page d'accueil).
    var kitParam = new URLSearchParams(location.search).get("kit");
    if (kitParam) { var choix = $("input[data-kit='" + kitParam + "']", achat); if (choix) choix.checked = true; }
    majPrix();
  }

  /* Galerie : défilement, vignettes, points, flèches */
  function initGalerie(g) {
    if (g.__init) return; g.__init = true;
    var slides = $(".galerie__slides", g);
    var items = $$(".galerie__slide", g);
    var vignettes = $$(".galerie__vignettes button", g);
    var points = $(".galerie__points", g);
    if (points) { points.innerHTML = ""; items.forEach(function () { points.appendChild(document.createElement("span")); }); }
    // Pas d'une photo à la suivante : toute la largeur sur ordinateur, 70 % + l'écart sur mobile (photo suivante visible).
    var pas = function () { return items.length > 1 ? Math.max(1, items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left) : Math.max(1, slides.clientWidth); };
    // Photo active : celle dont la position d'accroche (i × pas, plafonnée au défilement maximal) est la plus proche ;
    // sur écran court (photos réduites), la dernière ne peut pas atteindre i × pas.
    var actif = function () {
      var max = Math.max(0, slides.scrollWidth - slides.clientWidth), x = slides.scrollLeft, p = pas(), n = 0, ecart = Infinity;
      items.forEach(function (_, i) { var d = Math.abs(Math.min(max, i * p) - x); if (d < ecart) { ecart = d; n = i; } });
      return n;
    };
    var maj = function () {
      var n = actif();
      vignettes.forEach(function (v, i) { v.classList.toggle("is-on", i === n); v.setAttribute("aria-current", i === n ? "true" : "false"); });
      if (points) $$("span", points).forEach(function (p, i) { p.classList.toggle("is-on", i === n); });
    };
    var aller = function (n) { slides.scrollTo({ left: n * pas(), behavior: reduit ? "auto" : "smooth" }); };
    g.__aller = aller;
    vignettes.forEach(function (v, i) { v.addEventListener("click", function () { aller(i); }); });
    var p = $(".galerie__fleche--g", g), s = $(".galerie__fleche--d", g);
    if (p) p.addEventListener("click", function () { aller(Math.max(0, actif() - 1)); });
    if (s) s.addEventListener("click", function () { aller(Math.min(items.length - 1, actif() + 1)); });
    slides.addEventListener("scroll", function () { window.requestAnimationFrame(maj); }, { passive: true });
    maj();
  }
  $$("[data-galerie]").forEach(function (g) { if (!g.hidden) initGalerie(g); });

  /* Filtres d'avis */
  $$("[data-filtres]").forEach(function (barreF) {
    var cible = $(barreF.getAttribute("data-filtres"));
    $$("button", barreF).forEach(function (b) {
      b.addEventListener("click", function () {
        $$("button", barreF).forEach(function (x) { x.classList.toggle("is-on", x === b); x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        var f = b.getAttribute("data-filtre");
        $$(".avis", cible).forEach(function (a) { a.hidden = f !== "tous" && (a.getAttribute("data-tags") || "").indexOf(f) < 0; });
      });
    });
  });
  /* ================================================================ VITRINE DES COMPOSANTS (composants.html)
     Démos légères de la maquette : chaque bloc ne s'active que si son balisage est présent. Rien n'est envoyé. */
  (function () {
    // Copie dans le presse-papiers, avec repli si l'API Clipboard est absente ou refusée
    var copier = function (texte) {
      var repli = function () {
        return new Promise(function (ok, ko) {
          var t = document.createElement("textarea");
          t.value = texte; t.setAttribute("readonly", ""); t.style.cssText = "position:fixed;top:0;left:0;opacity:0";
          document.body.appendChild(t); t.select();
          var r = false; try { r = document.execCommand("copy"); } catch (e) {}
          t.remove(); if (r) ok(); else ko();
        });
      };
      return navigator.clipboard && window.isSecureContext ? navigator.clipboard.writeText(texte).catch(repli) : repli();
    };
    var retour = function (bloc, txt, erreur) {
      var el = $("[data-form-retour]", bloc); if (!el) return;
      el.textContent = txt; el.classList.toggle("is-erreur", !!erreur);
    };
    var valider = function (f) {
      var ko = $$("[required]", f).filter(function (c) { var bad = !c.value.trim() || !c.checkValidity(); c.setAttribute("aria-invalid", bad ? "true" : "false"); return bad; });
      if (ko.length) ko[0].focus();
      return !ko.length;
    };

    // 40 Progression de lecture et 41 retour en haut
    var barreL = $("[data-progression-lecture]"), pct = $("[data-progression-pct]"), haut = $("[data-retour-haut]");
    if (barreL || haut) {
      var prevu = false;
      var majDefil = function () {
        prevu = false;
        var max = document.documentElement.scrollHeight - window.innerHeight, p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
        if (barreL) barreL.style.transform = "scaleX(" + p.toFixed(4) + ")";
        if (pct) pct.textContent = Math.round(p * 100) + " %";
        if (haut) haut.classList.toggle("is-visible", window.scrollY > window.innerHeight * 1.5);
      };
      window.addEventListener("scroll", function () { if (!prevu) { prevu = true; requestAnimationFrame(majDefil); } }, { passive: true });
      window.addEventListener("resize", majDefil);
      majDefil();
      if (haut) haut.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduit ? "auto" : "smooth" }); });
    }

    // Boutons d'ajout de démonstration
    $$("[data-demo-ajout]").forEach(function (b) {
      var libelle = b.innerHTML, t;
      b.addEventListener("click", function () {
        b.textContent = b.getAttribute("data-demo-ajout"); b.classList.add("is-fait");
        clearTimeout(t); t = setTimeout(function () { b.innerHTML = libelle; b.classList.remove("is-fait"); }, 2200);
      });
    });

    // 8, 31 Formulaires de démonstration ; 8 aperçu de la photo choisie
    $$("form[data-form-demo]").forEach(function (f) {
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!valider(f)) { retour(f.parentNode, "Vérifiez les champs signalés.", true); return; }
        retour(f.parentNode, f.getAttribute("data-form-demo"));
        f.reset();
      });
    });
    $$("input[data-depot]").forEach(function (inp) {
      var champ = inp.closest(".champ"), nom = $("[data-depot-nom]", champ), apercu = $("[data-depot-apercu]", champ), url = null;
      var vider = function () { if (url) URL.revokeObjectURL(url); url = null; apercu.hidden = true; apercu.removeAttribute("src"); nom.textContent = "Choisir une photo"; };
      inp.addEventListener("change", function () {
        var fichier = inp.files && inp.files[0];
        if (!fichier) { vider(); return; }
        if (url) URL.revokeObjectURL(url);
        url = URL.createObjectURL(fichier); apercu.src = url; apercu.hidden = false; nom.textContent = fichier.name;
      });
      if (inp.form) inp.form.addEventListener("reset", function () { setTimeout(vider, 0); });
    });

    // 9 Onglets (flèches gauche et droite au clavier)
    $$("[data-onglets]").forEach(function (o) {
      var tabs = $$("[role=tab]", o);
      var choisir = function (t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1;
          document.getElementById(x.getAttribute("aria-controls")).hidden = !on;
        });
        if (focus) t.focus();
      };
      tabs.forEach(function (t, k) {
        t.addEventListener("click", function () { choisir(t); });
        t.addEventListener("keydown", function (e) {
          var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
          if (d) { e.preventDefault(); choisir(tabs[(k + d + tabs.length) % tabs.length], true); }
        });
      });
    });

    // 14 Produit mis en avant : prix selon la contenance
    $$("[data-vedette]").forEach(function (v) {
      var prix = $("[data-vedette-prix]", v);
      $$("input[type=radio]", v).forEach(function (r) { r.addEventListener("change", function () { prix.textContent = euros(parseFloat(r.value)); }); });
    });

    // 22 Diaporama de héros : 6 s par diapositive, pause au survol, au focus et au bouton, arrêt hors écran
    $$("[data-diapo]").forEach(function (d) {
      var slides = $$(".diapo__slide", d), points = $("[data-diapo-points]", d), pause = $("[data-diapo-pause]", d);
      var i = 0, minut = null, arret = reduit, visible = !IO;
      var aller = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { var on = k === i; s.classList.toggle("is-active", on); s.setAttribute("aria-hidden", on ? "false" : "true"); s.inert = !on; });
        $$("button", points).forEach(function (b, k) { b.setAttribute("aria-current", k === i ? "true" : "false"); });
      };
      var relancer = function () { clearInterval(minut); if (!arret && visible) minut = setInterval(function () { aller(i + 1); }, 6000); };
      slides.forEach(function (s, k) {
        var b = document.createElement("button");
        b.type = "button"; b.setAttribute("aria-label", "Diapositive " + (k + 1));
        b.addEventListener("click", function () { aller(k); relancer(); });
        points.appendChild(b);
      });
      $("[data-diapo-prec]", d).addEventListener("click", function () { aller(i - 1); relancer(); });
      $("[data-diapo-suiv]", d).addEventListener("click", function () { aller(i + 1); relancer(); });
      var majPause = function () { pause.setAttribute("aria-label", arret ? "Lancer le défilement" : "Mettre en pause"); $("use", pause).setAttribute("href", arret ? "#i-play" : "#i-pause"); };
      pause.addEventListener("click", function () { arret = !arret; majPause(); relancer(); });
      d.addEventListener("mouseenter", function () { clearInterval(minut); });
      d.addEventListener("mouseleave", relancer);
      d.addEventListener("focusin", function () { clearInterval(minut); });
      d.addEventListener("focusout", function (e) { if (!d.contains(e.relatedTarget)) relancer(); });
      aller(0); majPause();
      if (IO) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; relancer(); }).observe(d); else relancer();
    });

    // 26 Stories (vitrine et section to-stories) : une visionneuse par bloc [data-stories]. Défilement automatique
    // (durée --story-duree, ou celle de la vidéo), pause en gardant le doigt appuyé ou à la barre d'espace,
    // zones précédente et suivante, flèches et Échap. Mouvement réduit : pas de défilement automatique.
    $$("[data-stories]").forEach(function (bloc) {
      var vis = $("[data-visionneuse]", bloc);
      if (!vis || typeof vis.showModal !== "function") return;
      var stories = $$("[data-story]", bloc), cur = 0, appui = 0, tenu = false;
      var cadre = $(".visionneuse__cadre", vis), barres = $(".visionneuse__barres", vis), img = $(".visionneuse__img", vis);
      var video = $(".visionneuse__video", vis), lien = $(".visionneuse__lien", vis);
      barres.innerHTML = stories.map(function () { return "<span><i></i></span>"; }).join("");
      var pause = function (on) {
        vis.classList.toggle("is-pause", on);
        if (video && !video.hidden) { if (on) video.pause(); else if (!reduit) video.play().catch(function () {}); }
      };
      var montrer = function (n) {
        if (n < 0) n = 0;
        if (n >= stories.length) { vis.close(); return; }
        cur = n; pause(false);
        var s = stories[n], src = s.getAttribute("data-video"), trait = barres.children[n].firstChild;
        img.src = s.getAttribute("data-src"); img.alt = "";
        if (video) {
          video.pause(); video.hidden = !src;
          if (src) {
            video.src = src; video.poster = s.getAttribute("data-src"); video.controls = reduit;
            video.onloadedmetadata = function () { if (video.duration && isFinite(video.duration)) trait.style.animationDuration = video.duration + "s"; };
            if (!reduit) video.play().catch(function () {});
          } else { video.removeAttribute("src"); }
        }
        $(".visionneuse__titre", vis).textContent = s.getAttribute("data-titre") || "";
        $(".visionneuse__texte", vis).textContent = s.getAttribute("data-texte") || "";
        if (lien) {
          var href = s.getAttribute("data-lien");
          lien.hidden = !href;
          if (href) { lien.href = href; lien.textContent = s.getAttribute("data-lien-texte") || "En savoir plus"; }
        }
        $$("span", barres).forEach(function (b, k) { b.className = k < n ? "is-vu" : k === n ? "is-on" : ""; b.firstChild.style.animationDuration = ""; });
        trait.style.animation = "none"; void trait.offsetWidth; trait.style.animation = "";
        s.classList.add("is-vue");
      };
      barres.addEventListener("animationend", function () { if (!stories[cur].getAttribute("data-video")) montrer(cur + 1); });
      if (video) video.addEventListener("ended", function () { montrer(cur + 1); });
      stories.forEach(function (s, k) { s.addEventListener("click", function () { vis.showModal(); montrer(k); }); });
      // Doigt appuyé plus de 250 ms : pause, sans changer de story au relâchement
      cadre.addEventListener("pointerdown", function (e) {
        if (e.target.closest("a, [data-story-fermer]")) return;
        appui = Date.now(); tenu = false;
        setTimeout(function () { if (appui && Date.now() - appui >= 250) { tenu = true; pause(true); } }, 260);
      });
      ["pointerup", "pointercancel", "pointerleave"].forEach(function (t) {
        cadre.addEventListener(t, function () { if (appui) { appui = 0; if (tenu) pause(false); } });
      });
      var zone = function (sens) { return function () { if (tenu) { tenu = false; return; } montrer(cur + sens); }; };
      $("[data-story-prec]", vis).addEventListener("click", zone(-1));
      $("[data-story-suiv]", vis).addEventListener("click", zone(1));
      $("[data-story-fermer]", vis).addEventListener("click", function () { vis.close(); });
      if (lien) lien.addEventListener("click", function () { vis.close(); });
      vis.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") montrer(cur + 1);
        if (e.key === "ArrowLeft") montrer(cur - 1);
        if (e.key === " " && !e.target.closest("a")) { e.preventDefault(); pause(!vis.classList.contains("is-pause")); }
      });
      vis.addEventListener("close", function () {
        if (video) { video.pause(); video.removeAttribute("src"); video.hidden = true; }
        vis.classList.remove("is-pause");
        $$("span", barres).forEach(function (b) { b.className = ""; });
        if (stories[cur]) stories[cur].focus();
      });
    });

    // 27 Vidéos verticales : message d'attente au clic
    $$("[data-video-attente]").forEach(function (b) {
      var msg = $(".video-v__msg", b), t;
      b.addEventListener("click", function () {
        msg.textContent = "Vidéo à venir"; b.classList.add("is-msg");
        clearTimeout(t); t = setTimeout(function () { b.classList.remove("is-msg"); }, 2400);
      });
    });

    // 32 Image à points cliquables (vitrine et section to-points) : un seul point ouvert, fermeture au clic ailleurs et à Échap
    $$("[data-points]").forEach(function (zone) {
      var pts = $$(".point", zone);
      var bulle = function (p) { return document.getElementById(p.getAttribute("aria-controls")); };
      var fermer = function (sauf) { pts.forEach(function (p) { if (p !== sauf) { p.setAttribute("aria-expanded", "false"); bulle(p).hidden = true; } }); };
      pts.forEach(function (p) {
        p.addEventListener("click", function () {
          var ouvert = p.getAttribute("aria-expanded") === "true";
          fermer(p); p.setAttribute("aria-expanded", ouvert ? "false" : "true"); bulle(p).hidden = ouvert;
        });
      });
      document.addEventListener("click", function (e) { if (!e.target.closest(".point, .point__bulle")) fermer(); });
      zone.addEventListener("keydown", function (e) {
        if (e.key !== "Escape") return;
        var ouvert = pts.filter(function (p) { return p.getAttribute("aria-expanded") === "true"; })[0];
        fermer(); if (ouvert) ouvert.focus();
      });
    });

    // 39 Suivi de commande (démo)
    $$("form[data-suivi]").forEach(function (f) {
      var bloc = f.parentNode, res = $("[data-suivi-resultat]", bloc), attente = $("[data-suivi-attente]", bloc);
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!valider(f)) { retour(f, "Renseignez le numéro et l'email de la commande.", true); return; }
        retour(f, "");
        var n = $("input[type=text]", f).value.trim().replace(/^#/, "");
        $("[data-suivi-numero]", bloc).textContent = "#" + n;
        res.hidden = false; if (attente) attente.hidden = true;
      });
    });

    // 46, 50 Offres à cocher : total et bouton suivent les cases
    $$("form[data-ensemble]").forEach(function (f) {
      var cases = $$("input[type=checkbox]", f), totalEl = $("[data-ensemble-total]", f), btn = $("[data-ensemble-btn]", f);
      var base = parseFloat(f.getAttribute("data-base") || "0");
      var maj = function () {
        var n = 0, c = Math.round(base * 100);
        cases.forEach(function (x) {
          if (x.checked) { n++; c += Math.round(parseFloat(x.getAttribute("data-prix")) * 100); }
          var visuel = $("[data-produit='" + x.value + "']", f); if (visuel) visuel.classList.toggle("is-off", !x.checked);
        });
        totalEl.textContent = euros(c / 100);
        if (btn) { btn.disabled = !n; btn.textContent = n === 0 ? "Cochez au moins un produit" : n === 1 ? "Ajouter ce produit au panier" : "Ajouter les " + n + " au panier"; }
        return n;
      };
      cases.forEach(function (x) { x.addEventListener("change", function () { maj(); retour(f, ""); }); });
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var n = maj(), quoi = base ? (n ? "Kit et " + n + " complément" + (n > 1 ? "s" : "") + " ajoutés" : "Kit ajouté") : n + " produit" + (n > 1 ? "s ajoutés" : " ajouté");
        retour(f, quoi + " au panier (démo) : " + totalEl.textContent + ".");
      });
      maj();
    });

    // 48 Cadeau selon la quantité
    $$("[data-cadeau]").forEach(function (b) {
      var champ = $("input", b), seuil = parseInt(b.getAttribute("data-cadeau"), 10), unit = parseFloat(b.getAttribute("data-prix"));
      var jauge = $(".jauge-panier", b), msg = $("[data-cadeau-msg]", b), offert = $("[data-cadeau-offert]", b);
      var maj = function () {
        var q = Math.max(1, Math.min(9, parseInt(champ.value, 10) || 1)), ok = q >= seuil, reste = seuil - q;
        champ.value = q;
        jauge.classList.toggle("is-atteint", ok);
        $(".jauge span", b).style.width = Math.min(100, q / seuil * 100) + "%";
        msg.textContent = ok ? "Loupe x10 offerte, ajoutée à votre commande" : "Encore " + reste + " kit" + (reste > 1 ? "s" : "") + " pour recevoir la loupe x10 offerte";
        offert.hidden = !ok;
        $("[data-cadeau-prix]", b).textContent = euros(Math.round(q * unit * 100) / 100);
      };
      $$("[data-qte]", b).forEach(function (btn) { btn.addEventListener("click", function () { champ.value = (parseInt(champ.value, 10) || 1) + parseInt(btn.getAttribute("data-qte"), 10); maj(); }); });
      champ.addEventListener("change", maj);
      maj();
    });

    // 49 Code promo cliquable : copie et application visibles
    $$("[data-code-promo]").forEach(function (b) {
      var bloc = b.closest("[data-promo-bloc]"), etat = $("[data-promo-etat]", bloc), action = $("[data-promo-action]", bloc);
      b.addEventListener("click", function () {
        var code = b.getAttribute("data-code-promo");
        var fin = function (copie) {
          bloc.classList.remove("is-applique"); void bloc.offsetWidth; bloc.classList.add("is-applique");
          action.textContent = copie ? "Copié et appliqué" : "Appliqué";
          etat.textContent = copie ? "Le code " + code + " est copié et la remise de 15 % s'applique au kit." : "Remise appliquée. La copie automatique n'a pas fonctionné : notez le code " + code + ".";
        };
        copier(code).then(function () { fin(true); }, function () { fin(false); });
      });
    });

    // 56 Stock restant honnête (le curseur simule l'inventaire Shopify)
    $$("[data-stock]").forEach(function (b) {
      var r = $("input[type=range]", b), msg = $("[data-stock-msg]", b);
      var maj = function () {
        var n = parseInt(r.value, 10);
        $("[data-stock-valeur]", b).textContent = n;
        msg.className = "stock-msg " + (n === 0 ? "is-epuise" : n < 5 ? "is-bas" : "is-ok");
        $("[data-stock-texte]", b).textContent = n === 0 ? "Épuisé : prévenez-moi du retour" : n < 5 ? "Plus que " + n + " en stock" : "En stock, expédié sous 24 h ouvrées";
      };
      r.addEventListener("input", maj); maj();
    });

    // 58 Fenêtre d'information (dialog natif : Échap ferme, clic sur le voile aussi)
    $$("[data-modale-ouvrir]").forEach(function (b) {
      var d = document.getElementById(b.getAttribute("data-modale-ouvrir"));
      if (!d || typeof d.showModal !== "function") return;
      b.addEventListener("click", function () { d.showModal(); });
      d.addEventListener("click", function (e) { if (e.target === d || e.target.closest("[data-modale-fermer]")) d.close(); });
    });

    // 62 Partager (vitrine, fiche produit, article) : menu natif du téléphone, sinon copie du lien
    $$("[data-partager]").forEach(function (b) {
      var etat = $("[data-partager-etat]", b.parentNode), t;
      var dire = function (txt) { etat.textContent = txt; clearTimeout(t); t = setTimeout(function () { etat.textContent = ""; }, 3000); };
      b.addEventListener("click", function () {
        var url = b.getAttribute("data-url") || location.href, donnees = { title: document.title, text: b.getAttribute("data-partager"), url: url };
        if (navigator.share) { navigator.share(donnees).catch(function () {}); return; }
        copier(url).then(function () { dire("Lien copié : collez-le où vous voulez."); }, function () { dire("Copiez le lien depuis la barre d'adresse."); });
      });
    });

    // 71 Code promo dans le panier (MYSTERE15 : -15 % sur le kit)
    $$("[data-panier-code]").forEach(function (p) {
      var form = $("[data-code-panier-form]", p), champ = $("input", form), etat = $("[data-code-panier-etat]", p), ligne = $("[data-code-panier-remise]", p);
      var st = Math.round(parseFloat(p.getAttribute("data-sous-total")) * 100), base = Math.round(parseFloat(p.getAttribute("data-base-remise")) * 100);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var code = champ.value.trim().toUpperCase(), remise = 0;
        if (!code) { etat.textContent = "Saisissez un code."; etat.classList.add("is-erreur"); return; }
        if (code === "MYSTERE15") {
          remise = Math.round(base * 15 / 100);
          $("[data-code-panier-montant]", p).textContent = "-" + euros(remise / 100);
          etat.textContent = "Code MYSTERE15 appliqué."; etat.classList.remove("is-erreur");
        } else {
          etat.textContent = "Ce code n'existe pas ou a expiré."; etat.classList.add("is-erreur");
        }
        ligne.hidden = !remise;
        $("[data-code-panier-total]", p).textContent = euros((st - remise) / 100);
      });
    });

    // 72 Note de commande
    $$("form[data-note-commande]").forEach(function (f) {
      var t = $("textarea", f), compte = $("[data-note-compte]", f);
      t.addEventListener("input", function () { compte.textContent = t.value.length; retour(f, ""); });
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var vide = !t.value.trim();
        retour(f, vide ? "La note est vide." : "Note enregistrée : elle sera jointe à la commande (démo).", vide);
      });
    });
  })();

  /* ---------------------------------------------- Quiz « Quel kit vous faut-il ? » */
  $$("[data-quiz]").forEach(function (quiz) {
    // Quiz : 3 questions au plus sur ce que le client veut vérifier, une question conditionnelle (titre de l'or jaune).
    // Pas de saut de page : hauteur verrouillée pendant le changement d'écran, défilement doux seulement si le haut du quiz est caché.
    var src = $("[data-quiz-donnees]", quiz); if (!src) return;
    var D = JSON.parse(src.textContent), rep = {}, pile = [];
    var intro = $("[data-quiz-intro]", quiz);
    // 1er nov. 2026 (A32) : sur la page quiz, la question 1 est déjà écrite dans le HTML par sections/to-quiz.liquid : on reprend ce bloc au lieu de le recréer.
    var ecran = $(".quiz__ecran", quiz), dejaRendu = !!ecran;
    if (!ecran) {
      ecran = document.createElement("div"); ecran.className = "quiz__ecran is-entre"; ecran.setAttribute("aria-live", "polite");
      quiz.appendChild(ecran);
    }
    var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    var visible = function (q) { return Object.keys(q.si || {}).every(function (k) { return (q.si[k] || []).indexOf(rep[k]) >= 0; }); };
    // Questions encore possibles : une question conditionnelle compte tant que sa condition n'est pas tranchée.
    var possible = function (q) { return Object.keys(q.si || {}).every(function (k) { return rep[k] === undefined || (q.si[k] || []).indexOf(rep[k]) >= 0; }); };
    var suivantes = function (depuis) { return D.questions.filter(function (q, i) { return i >= depuis && possible(q); }); };
    var montrer = function (html, vite) {
      var h = Math.max(ecran.offsetHeight, intro && !intro.hidden ? intro.offsetHeight : 0);
      ecran.style.minHeight = h + "px";
      ecran.classList.remove("is-entre");
      setTimeout(function () {
        if (intro) intro.hidden = true;
        ecran.innerHTML = html; void ecran.offsetWidth; ecran.classList.add("is-entre");
        ecran.style.minHeight = "";
        var haut = quiz.getBoundingClientRect().top;
        if (haut < 0 || haut > window.innerHeight * 0.6) quiz.scrollIntoView({ behavior: reduit ? "auto" : "smooth", block: "start" });
        var f = $(".quiz__q", ecran); if (f && !vite) f.focus({ preventScroll: true });
      }, reduit || vite ? 0 : 160);
    };
    var question = function (i, vite) {
      var q = D.questions[i], total = pile.length + suivantes(i).length, n = pile.length + 1;
      var h = '<div class="quiz__progres"><span style="width:' + Math.round((n - 1) / total * 100) + '%"></span></div>' +
        '<p class="quiz__compte">Question ' + n + " sur " + total + '</p><h2 class="h2 quiz__q" tabindex="-1">' + esc(q.titre) + "</h2>" +
        (q.aide ? '<p class="quiz__aide">' + esc(q.aide) + "</p>" : "") + '<div class="quiz__choix">';
      q.reponses.forEach(function (r) {
        var vis = r.poincon ? '<span class="quiz__poincon" aria-hidden="true"><b>' + esc(r.poincon) + "</b></span>"
                            : '<img src="' + esc(r.img) + '" alt="" width="192" height="192">';
        h += '<button type="button" class="quiz__carte' + (rep[q.cle] === r.v ? " is-choisie" : "") + '" data-v="' + esc(r.v) + '">' +
          '<span class="quiz__img">' + vis + "</span><strong>" + esc(r.l) + "</strong><small>" + esc(r.d) + "</small></button>";
      });
      h += "</div>" + (pile.length ? '<button type="button" class="quiz__retour" data-retour>← Question précédente</button>' : "");
      quiz.__i = i;
      montrer(h, vite);
    };
    var euro = function (x) { return Number(x).toFixed(2).replace(".", ",") + " €"; };
    var resultat = function () {
      var match = function (si) { return Object.keys(si).every(function (k) { return rep[k] === si[k]; }); };
      var regle = D.regles.filter(function (r) { return match(r.si); })[0];
      var vol = (D.volume15.quantite || []).indexOf(rep.quantite) >= 0 ? 15 : 5;
      var p = D.produits[regle.produit], s = D.produits[regle.second];
      var choisir = function (x) {
        var vs = (x && x.variantes || []).filter(function (v) { return v.dispo; });
        var ok = function (v, strict) {
          var t = v.titre || "";
          if (/ml/.test(t) && t.indexOf(vol + " ml") !== 0) return false;
          if (strict && regle.variante.pierre && /×|x/.test(t) && t.indexOf(regle.variante.pierre === 150 ? "150" : "62") < 0) return false;
          if (strict && regle.variante.balance !== undefined && /balance/i.test(t) && /avec balance/i.test(t) !== !!regle.variante.balance) return false;
          return true;
        };
        return vs.filter(function (v) { return ok(v, true); })[0] || vs.filter(function (v) { return ok(v, false); })[0] || vs[0];
      };
      var v = choisir(p), v2 = choisir(s);
      var detail = v && v.titre !== "Default Title" ? v.titre : "";
      var lien = function (x, w) { return x.url + (w && /^\d+$/.test(String(w.id)) ? (x.url.indexOf("?") < 0 ? "?" : "&") + "variant=" + w.id : ""); };
      // Deux propositions côte à côte, la moins chère puis la plus complète (tri par prix croissant).
      var carte = function (x, w, raison, etiquette, reco) {
        var det = w && w.titre !== "Default Title" ? w.titre : "";
        return '<article class="quiz__revele quiz__revele--duo' + (reco ? " is-reco" : "") + '">' +
          (reco ? '<span class="quiz__badge">Notre recommandation</span>' : "") +
          '<img src="' + esc(x.image) + '" alt="' + esc(x.nom) + '" width="600" height="600"><div class="quiz__fiche">' +
          (etiquette ? '<p class="quiz__niveau">' + esc(etiquette) + "</p>" : "") +
          '<h2 class="h2">' + esc(x.nom) + "</h2>" +
          (det ? '<p class="quiz__variante">' + esc(det) + "</p>" : "") +
          (raison ? '<p class="quiz__pourquoi">' + esc(raison) + "</p>" : "") +
          (w ? '<p class="quiz__prix">' + euro(w.prix) + "</p>" : "") +
          '<div class="quiz__actions">' +
          (w ? '<button type="button" class="btn btn--primary btn--lg" data-quiz-ajout="' + esc(w.id) + '">Ajouter au panier</button>' : "") +
          '<a class="btn btn--ghost" href="' + esc(lien(x, w)) + '">Voir le kit</a></div>' +
          (x.codes && x.codes.length ? '<p class="quiz__ajuster">Besoin d\'un autre réactif ? <a href="' + esc(D.composeur + "?reactifs=" + x.codes.join(",") + "&vol=" + vol) + '">Ajustez-le sur mesure</a></p>' : "") +
          "</div></article>";
      };
      var paire = [{ x: p, w: v, r: regle.raison, reco: true }];
      if (s && v2) paire.push({ x: s, w: v2, r: regle.raison_second || "", reco: false });
      paire.sort(function (a, b) { return (a.w ? a.w.prix : 0) - (b.w ? b.w.prix : 0) || (b.reco ? 1 : 0) - (a.reco ? 1 : 0); });
      var deux = paire.length === 2;
      var ecart = deux && paire[0].w && paire[1].w && paire[0].w.prix < paire[1].w.prix;
      var h = '<div class="quiz__resultat"><p class="eyebrow">' + (deux ? "Nos deux recommandations" : "Le kit qu'il vous faut") + "</p>" +
        '<div class="quiz__duo' + (deux ? "" : " quiz__duo--seul") + '">' +
        paire.map(function (e, i) {
          return carte(e.x, e.w, e.r, ecart ? (i === 0 ? "Le plus économique" : "Le plus complet") : (deux && !e.reco ? "Autre option" : ""), e.reco);
        }).join("") + "</div>";
      if (D.code) h += '<div class="quiz__cadeau" data-cadeau><p><strong>Bonus débloqué :</strong> une remise vous attend.</p>' +
        '<button type="button" class="btn btn--ivoire" data-gratter>Découvrir ma remise</button></div>';
      h += '<button type="button" class="quiz__retour" data-recommencer>Refaire le quiz</button></div>';
      montrer(h);
    };
    var avancer = function () {
      var reste = D.questions.map(function (q, i) { return i; }).filter(function (i) { return i > quiz.__i && visible(D.questions[i]); });
      if (reste.length) question(reste[0]); else resultat();
    };
    quiz.addEventListener("click", function (e) {
      var c = e.target.closest(".quiz__carte"), t;
      if (e.target.closest("[data-quiz-start]")) { rep = {}; pile = []; question(0); return; }
      if (c) {
        var q = D.questions[quiz.__i];
        rep[q.cle] = c.getAttribute("data-v");
        Object.keys(rep).forEach(function (k) { var qq = D.questions.filter(function (x) { return x.cle === k; })[0]; if (qq && !visible(qq)) delete rep[k]; });
        $$(".quiz__carte", ecran).forEach(function (b) { b.classList.toggle("is-choisie", b === c); });
        pile.push(quiz.__i);
        setTimeout(avancer, reduit ? 0 : 220); return;
      }
      if (e.target.closest("[data-retour]")) { question(pile.pop()); return; }
      if (e.target.closest("[data-recommencer]")) { rep = {}; pile = []; question(0); return; }
      if ((t = e.target.closest("[data-quiz-ajout]"))) {
        var items = [{ id: parseInt(t.getAttribute("data-quiz-ajout"), 10), quantity: 1 }];
        if (window.TestOrPanier) { t.setAttribute("aria-busy", "true"); window.TestOrPanier.ajouter(items, t).then(function () { t.removeAttribute("aria-busy"); }, function () { t.removeAttribute("aria-busy"); }); }
        else fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) }).then(function () { location.href = "/cart"; });
        return;
      }
      if ((t = e.target.closest("[data-gratter]"))) {
        var boite = t.parentNode; boite.classList.add("is-revele");
        boite.innerHTML = '<p><strong>Votre code</strong></p><p class="quiz__code">' + esc(D.code) + '</p><p class="quiz__note">À saisir dans le panier.</p>';
        try { navigator.clipboard && navigator.clipboard.writeText(D.code); } catch (er) {}
      }
    });
    // Page dédiée au quiz : la première question s'affiche tout de suite, sans écran d'introduction.
    if (quiz.hasAttribute("data-quiz-auto")) { rep = {}; pile = []; if (dejaRendu) quiz.__i = 0; else question(0, true); }
  });

  /* ------------------------------------------ Mur de photos : pause au toucher (reprise 4 s après) */
  $$("[data-mur]").forEach(function (mur) {
    var t;
    mur.addEventListener("touchstart", function () { mur.classList.add("is-pause"); clearTimeout(t); }, { passive: true });
    mur.addEventListener("touchend", function () { clearTimeout(t); t = setTimeout(function () { mur.classList.remove("is-pause"); }, 4000); }, { passive: true });
  });

  /* ------------------------------------------ Compteur réel : comptage animé à l'apparition */
  if (IO && !reduit) {
    $$("[data-compter]").forEach(function (el) {
      var fin = parseInt(el.getAttribute("data-compter"), 10), texte = el.textContent;
      if (!fin || el.getBoundingClientRect().top <= window.innerHeight) return;
      var o = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; o.disconnect();
        animer(1200, function (p) { el.textContent = p < 1 ? Math.round(fin * p).toLocaleString("fr-FR") : texte; });
      }, { rootMargin: "0px 0px 80px 0px" });
      o.observe(el);
    });
  }

  /* ------------------------------------------ Landing : sommaire automatique et barre de lecture */
  $$("[data-landing-corps]").forEach(function (corps, n) {
    var nav = $("[data-sommaire]"), liste = nav && $("ol", nav), titres = $$("h2", corps);
    if (liste && titres.length) {
      titres.forEach(function (h, i) {
        if (!h.id) h.id = "partie-" + (n + 1) + "-" + (i + 1);
        var li = document.createElement("li"), a = document.createElement("a");
        a.href = "#" + h.id; a.textContent = h.textContent; li.appendChild(a); liste.appendChild(li);
      });
      if (IO) {
        var liens = $$("a", liste), oT = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) liens.forEach(function (a) { a.classList.toggle("is-actif", a.getAttribute("href") === "#" + e.target.id); }); });
        }, { rootMargin: "0px 0px -70% 0px" });
        titres.forEach(function (h) { oT.observe(h); });
      }
    } else if (nav) nav.hidden = true;
    var barre = $("[data-lecture-barre] span");
    if (barre) {
      var majL = function () {
        var r = corps.getBoundingClientRect(), total = r.height - window.innerHeight;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
        barre.style.transform = "scaleX(" + p + ")";
      };
      window.addEventListener("scroll", majL, { passive: true }); majL();
    }
  });

  /* ------------------------------------------ Landing : barre d'action collante */
  $$("[data-barre-action]").forEach(function (b) {
    var seuil = (parseInt(b.getAttribute("data-seuil"), 10) || 35) / 100;
    b.hidden = false;
    var majB = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      b.classList.toggle("is-visible", h > 0 && window.scrollY / h >= seuil && window.scrollY / h < .97);
    };
    window.addEventListener("scroll", majB, { passive: true }); majB();
  });

  /* ------------------------------------------ Landing : popup de page (une fois par session, jamais à l'arrivée) */
  $$("[data-popup-page]").forEach(function (pop) {
    var cle = "to-popup-" + location.pathname, vu = false;
    try { vu = sessionStorage.getItem(cle) === "1"; } catch (e) {}
    if (vu) return;
    var montrer = function () {
      if (vu) return; vu = true; pop.hidden = false;
      try { sessionStorage.setItem(cle, "1"); } catch (e) {}
    };
    var dec = pop.getAttribute("data-declencheur"), sec = Math.max(8, parseInt(pop.getAttribute("data-secondes"), 10) || 20);
    var pct = (parseInt(pop.getAttribute("data-pourcentage"), 10) || 50) / 100;
    if (dec === "secondes") setTimeout(montrer, sec * 1000);
    else if (dec === "sortie" && window.matchMedia("(pointer: fine)").matches) {
      setTimeout(function () { document.addEventListener("mouseout", function (e) { if (!e.relatedTarget && e.clientY <= 0) montrer(); }); }, 8000);
    } else {
      var ok = false; setTimeout(function () { ok = true; }, 8000);
      window.addEventListener("scroll", function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (ok && h > 0 && window.scrollY / h >= pct) montrer();
      }, { passive: true });
    }
    pop.addEventListener("click", function (e) {
      if (e.target.closest("[data-popup-fermer]")) pop.hidden = true;
      var m = e.target.closest("[data-popup-mystere]");
      if (m) { var code = m.getAttribute("data-popup-mystere"); m.outerHTML = '<p class="quiz__code" style="color:var(--bleu-logo)">' + code + "</p><p>-15 % avec ce code, à saisir dans le panier.</p>"; try { navigator.clipboard.writeText(code); } catch (er) {} }
    });
  });

  /* ------------------------------------------ Partage : copie du lien et partage natif */
  $$("[data-partage]").forEach(function (z) {
    var natif = $("[data-natif]", z);
    if (natif && navigator.share) { natif.hidden = false; natif.addEventListener("click", function () { navigator.share({ title: document.title, url: location.href }).catch(function () {}); }); }
    var c = $("[data-copier]", z);
    if (c) c.addEventListener("click", function () {
      var url = c.getAttribute("data-copier") || location.href, txt = c.textContent;
      var fini = function () { c.textContent = "Lien copié"; setTimeout(function () { c.textContent = txt; }, 2000); };
      try { navigator.clipboard.writeText(url).then(fini, fini); } catch (e) { fini(); }
    });
  });

  /* ------------------------------------------ Carte produit dans le contenu : ajout au panier */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-carte-ajout]"); if (!b || !window.TestOrPanier) return;
    window.TestOrPanier.ajouter([{ id: parseInt(b.getAttribute("data-carte-ajout"), 10), quantity: 1 }], b);
  });
  /* ---------------------------------------------------------------- Cadeaux à débloquer (formules, sélecteur de kits) */
  var majCadeaux = function (cadeaux, prix, anime) {
    cadeaux.forEach(function (k) {
      var s = parseFloat(k.getAttribute("data-seuil")), ok = prix >= s, avant = k.classList.contains("is-debloque");
      k.classList.toggle("is-debloque", ok);
      if (ok && !avant && anime && !reduit) { k.classList.remove("is-pop"); void k.offsetWidth; k.classList.add("is-pop"); }
      var etat = $("[data-cadeau-etat]", k);
      // Ligne de texte (data-ok, data-reste, ex. to-degressif) ou tuile (« Débloquée », « Plus que … »)
      var reste = euros(Math.round((s - prix) * 100) / 100);
      if (etat && etat.hasAttribute("data-ok")) etat.textContent = ok ? etat.getAttribute("data-ok") : "Plus que " + reste + " " + etat.getAttribute("data-reste");
      else if (etat) etat.textContent = ok ? "Débloquée" : "Plus que " + reste;
    });
  };
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ouvrir-mystere]")) { var o = document.getElementById("mystere-onglet"); if (o) o.click(); }
  });

  /* ---------------------------------------------------------------- Recharges : cadeaux à débloquer avec le panier actuel */
  $$("[data-cadeaux-panier]").forEach(function (cp) {
    var cForm = cp.closest("form");
    if (!cForm) return;
    var cCad = $$("[data-seuil]", cp), cPanier = 0;
    var cTotal = function () {
      var id = $("input[name='id']:checked", cForm) || $("input[type='hidden'][name='id']", cForm);
      var unit = id ? parseFloat(id.getAttribute("data-prix")) || 0 : 0;
      var q = $("input[name='to-quantite']:checked", cForm), n = q ? parseInt(q.value, 10) || 1 : 1, r = q ? parseFloat(q.getAttribute("data-remise")) || 0 : 0;
      return Math.round(Math.round(unit * 100) * n * (100 - r) / 100) / 100 + cPanier;
    };
    var cMaj = function (anime) { majCadeaux(cCad, cTotal(), anime); };
    cForm.addEventListener("change", function () { setTimeout(function () { cMaj(true); }, 0); }, true);
    if (cForm.hasAttribute("data-demo")) {
      try { (JSON.parse(localStorage.getItem("to-panier-demo") || "[]") || []).forEach(function (x) { cPanier += (x.prix || 0) * (x.quantite || 1); }); } catch (e) {}
    } else if (window.fetch) {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart.js").then(function (r) { return r.json(); })
        .then(function (c) { cPanier = (c.items_subtotal_price || c.total_price || 0) / 100; cMaj(false); }).catch(function () {});
    }
    cMaj(false);
  });

  /* ---------------------------------------------------------------- Introduction de collection repliée sur mobile (1er nov. 2026, benchmark P5) */
  $$("[data-intro-repli]").forEach(function (intro) {
    var suite = intro.nextElementSibling;
    if (!suite || !suite.hasAttribute("data-intro-suite") || !window.matchMedia("(max-width: 699px)").matches) return;
    var hauteurLigne = parseFloat(getComputedStyle(intro).lineHeight) || 24;
    if (intro.scrollHeight <= hauteurLigne * 4) return;
    intro.classList.add("is-replie"); suite.hidden = false;
    suite.addEventListener("click", function () {
      intro.classList.remove("is-replie"); suite.hidden = true; suite.setAttribute("aria-expanded", "true");
    });
  });

  /* ---------------------------------------------------------------- Sélecteur de kits de l'accueil */
  $$("[data-kits-selecteur]").forEach(function (ks) {
    var kCartes = $$("[data-ks]", ks), kPanneaux = $$("[data-ks-panneau]", ks), kCadeaux = $$("[data-seuil]", ks);
    var kChoisir = function (i, anime) {
      // 21 oct. 2026 : les cartes sont des liens ; aria-pressed n'est permis que sur un bouton (audit Lighthouse « navigation agentique »)
      kCartes.forEach(function (c, j) { c.classList.toggle("is-on", j === i); if (c.tagName === "BUTTON") c.setAttribute("aria-pressed", j === i ? "true" : "false"); else c.removeAttribute("aria-pressed"); });
      kPanneaux.forEach(function (pn, j) { pn.hidden = j !== i; });
      majCadeaux(kCadeaux, parseFloat(kCartes[i].getAttribute("data-prix")) || 0, anime);
    };
    kCartes.forEach(function (c, i) { c.addEventListener("click", function () { kChoisir(i, true); }); });
    // Maquette : ajout au panier de démonstration (Shopify : data-carte-ajout, géré plus haut)
    $$("[data-ks-demo]", ks).forEach(function (b) {
      b.addEventListener("click", function () { if (window.TestOrPanier) window.TestOrPanier.ajouter([JSON.parse(b.getAttribute("data-ks-demo"))], b); });
    });
    var k0 = kCartes.map(function (c) { return c.classList.contains("is-on"); }).indexOf(true);
    if (kCartes.length) kChoisir(k0 < 0 ? 0 : k0, false);
  });

  /* ---------------------------------------------------------------- FAQ en cartes : même hauteur que la carte promesse (ordinateur) */
  $$(".faq-grille").forEach(function (fg) {
    var carte = $(".faq-carte", fg), liste = $(".faq--cartes", fg), tete = $(".section-head", fg), mqFaq = window.matchMedia("(min-width: 980px)");
    if (!carte || !liste) return;
    var egaliser = function () {
      var items = $$("details", liste);
      liste.style.removeProperty("--faq-min");
      if (!mqFaq.matches || !items.length) return;
      // Mesure sans l'animation d'apparition (.revele décale de 18 px) ni la position collante
      fg.classList.add("faq-mesure");
      var hTete = tete ? tete.offsetHeight + parseFloat(getComputedStyle(tete).marginBottom || 0) : 0;
      var ecart = parseFloat(getComputedStyle(items[0]).marginBottom || 0);
      var dispo = carte.offsetHeight - hTete - ecart * (items.length - 1) - 2 * items.length; // 2 px : bordures de chaque carte
      var h = Math.max(56, Math.floor(dispo / items.length));
      liste.style.setProperty("--faq-min", h + "px");
      // Correction : écart mesuré entre le bas de la dernière question et le bas de la carte, réparti sur les questions
      var reste = carte.getBoundingClientRect().bottom - items[items.length - 1].getBoundingClientRect().bottom;
      if (Math.abs(reste) >= 1) liste.style.setProperty("--faq-min", Math.max(56, Math.floor(h + reste / items.length)) + "px");
      fg.classList.remove("faq-mesure");
    };
    egaliser();
    window.addEventListener("resize", egaliser);
    window.addEventListener("load", egaliser);
    if (mqFaq.addEventListener) mqFaq.addEventListener("change", egaliser);
  });

  /* ---------------------------------------------------------------- Formules des kits (cartes + cadeaux à débloquer) */
  $$("[data-formules]").forEach(function (fBloc) {
    var fForm = fBloc.closest("form"), fCache = fForm && $("input[name='id']", fForm);
    if (!fForm || !fCache) return;
    var fCartes = $$("[data-formule]", fBloc), fCadeaux = $$("[data-seuil]", fBloc), fPerso = $("[data-formules-perso]", fBloc);
    fForm.classList.add("a-formules");
    var fSelection = function () { return $$(".options", fForm).map(function (g) { var c = $("input:checked", g); return c ? c.value : null; }); };
    var fMaj = function (anime) {
      var sel = fSelection();
      fCartes.forEach(function (c) {
        var o = JSON.parse(c.getAttribute("data-formule")), on = o.every(function (v, i) { return v === sel[i]; });
        c.classList.toggle("is-on", on); c.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var q = $("input[name='quantity']", fForm), prix = (parseFloat(fCache.getAttribute("data-prix")) || 0) * (q ? Math.max(1, parseInt(q.value, 10) || 1) : 1);
      majCadeaux(fCadeaux, prix, anime);
    };
    fCartes.forEach(function (c) {
      c.addEventListener("click", function () {
        JSON.parse(c.getAttribute("data-formule")).forEach(function (val, i) {
          var r = $$("input[name='option-" + i + "']", fForm).filter(function (x) { return x.value === val; })[0];
          if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); }
        });
        fMaj(true);
      });
    });
    // Options modifiées à la main : la carte correspondante (ou aucune) et les cadeaux suivent
    fForm.addEventListener("change", function () { setTimeout(function () { fMaj(true); }, 0); }, true);
    fForm.addEventListener("input", function (e) { if (e.target.name === "quantity") setTimeout(function () { fMaj(true); }, 0); }, true);
    if (fPerso) fPerso.addEventListener("click", function () {
      var ouvert = fForm.classList.toggle("is-perso");
      fPerso.setAttribute("aria-expanded", ouvert ? "true" : "false");
    });
    fMaj(false);
  });

})();
